<aside class="col-md-12 mb-md-0 mb-12 h-100 px-0">
  <div id="mainDetailFreight" class="container-list position-relative" [ngClass]="{'m-1': isDialog }">
    <i *ngIf="isDialog" matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions"
      (click)="dialogRef.close()"></i>
    <div class="col-md-12" *ngIf="cargo?.id">
      <!-- Alerta unificada RNDC: remesa, manifiesto o ambos -->
      <ng-container *ngIf="getRndcContingencyAlertConfig() as alertConfig">
        <div *ngIf="alertConfig.shouldShow" class="alert d-flex align-items-start rndc-contingency-alert w-100"
          [ngClass]="alertConfig.alertClass" role="alert">
          <div class="d-flex align-items-start flex-grow-1">
            <i class="fas rndc-contingency-alert__icon" [ngClass]="alertConfig.iconClass" aria-hidden="true"></i>
            <div class="rndc-contingency-alert__content">
              <div class="rndc-contingency-alert__title">{{ alertConfig.title }}</div>
              <div class="rndc-contingency-alert__description">{{ alertConfig.description }}</div>
            </div>
          </div>
          <i class="fas fa-info-circle color-secondary-dark cursor-pointer ml-2" *ngIf="canOpenRndcContingencyHistory()"
            matTooltip="Ver información de la aprobación" matTooltipPosition="above"
            (click)="openRndcContingencyHistory()"></i>
        </div>
      </ng-container>
      <div class="row">
        <div class="col-md-12 px-0 px-md-3">
          <div class="row">
            <!-- Panel origen -->
            <div class="col-md-6 px-0" permission-display [module]="permission.cargo.module"
              [functionality]="permission.cargo.showOriginAddresses">
              <!-- Titulo Origen -->
              <div class="row">
                <div class="col-md-11 wrapper-label">
                  <label for="" class="title-1 w-auto">
                    Origen
                  </label>
                </div>
              </div>
              <div class="row panel-information">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-lg-6">
                      <!-- Ciudad de origen -->
                      <mat-card-content>
                        <div class="md-form">
                          <label class="title-2">Ciudad de origen</label>
                          <span class="text-bold">
                            {{ cargo?.cargoFeature?.uploadDownload?.origin?.name ?
                            cargo?.cargoFeature.uploadDownload.origin.name : '-' }}
                            {{cargo?.cargoFeature?.uploadDownload?.origin?.country?'('+cargo?.cargoFeature?.uploadDownload?.origin?.country?.name+')':''}}
                          </span>
                        </div>
                      </mat-card-content>
                    </div>
                    <div class="col-lg-6">
                      <mat-card-content>
                        <div class="md-form">
                          <label class="title-2">Fecha
                            {{isTransportService? 'de cargue': 'estimada de llegada al origen'}}
                          </label>
                          <span class="text-bold">
                            {{cargo?.dateLoad ? (cargo?.dateLoad | dateFormat:'only-date') : '-'}}
                          </span>
                        </div>
                      </mat-card-content>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Dirección de cargue  -->
              <div class="row panel-information panel-border-left"
                *ngFor="let upload of cargo?.cargoFeature.uploadDownload.origin.addresses; let i = index;">

                <div class="col-lg-5">
                  <mat-card-content class="col-md-12 mat-card-border">
                    <div class="md-form">
                      <label class="title-2">Hora {{isTransportService? 'de cargue '+ (i+1): 'estimada de llegada al
                        origen'}}
                      </label>
                      <span class="text-bold">
                        {{ upload.time? (upload.time | dateFormat: 'only-time'): '-'}}
                      </span>
                    </div>
                  </mat-card-content>
                </div>

                <div class="col-lg-7">
                  <mat-card-content class="col-md-12 mat-card-border">
                    <div class="md-form">
                      <label class="title-2">Dirección de {{isTransportService? 'cargue ' + (i+1): 'origen'}}</label>
                      <span class="text-bold">
                        {{upload.address}}
                      </span>
                    </div>
                  </mat-card-content>
                </div>
              </div>
            </div>
            <!-- Panel de destino -->
            <div class="col-md-6 px-0" permission-display [module]="permission.cargo.module"
              [functionality]="permission.cargo.showDestinationAddresses">
              <div class="row">
                <div class="col-md-11 wrapper-label">
                  <label for="" class="title-1 w-auto">
                    Destino
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12"
                  *ngFor=" let destination of cargo?.cargoFeature.uploadDownload.destination; let index = index;">
                  <!-- Ciudad de destino -->
                  <div class="row panel-information">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-lg-6">
                          <mat-card-content>
                            <div class="md-form">
                              <label class="title-2">Ciudad de destino {{index + 1}}</label>
                              <span class="text-bold">
                                {{destination.name}}{{destination.country?'('+destination.country.name+')':''}}
                              </span>
                            </div>
                          </mat-card-content>
                        </div>
                        <div class="col-lg-6">
                          <mat-card-content>
                            <div class="md-form">
                              <label class="title-2">Fecha
                                {{isTransportService? 'de descargue': 'estimada de llegada al destino'}}
                              </label>
                              <span class="text-bold">
                                {{destination.downloadDate ? (destination.downloadDate | dateFormat:'only-date'): '-'}}
                              </span>
                            </div>
                          </mat-card-content>
                        </div>
                      </div>

                    </div>
                  </div>
                  <!-- Dirección de descargue  -->
                  <div class="row panel-information panel-border-left"
                    *ngFor="let download of destination.addresses; let i = index;">

                    <div class="col-lg-5">
                      <mat-card-content class="col-md-12 mat-card-border">
                        <div class="md-form">
                          <label class="title-2">Hora
                            {{isTransportService? 'de descargue ' + (i+1): 'estimada de llegada al destino'}}
                          </label>
                          <span class="text-bold">
                            {{ download.time?(download.time | dateFormat: 'only-time'): '-'}}
                          </span>
                        </div>
                      </mat-card-content>
                    </div>


                    <div class="col-lg-7">
                      <mat-card-content class="col-md-12 mat-card-border">
                        <div class="md-form">
                          <label class="title-2">Dirección de {{isTransportService? 'descargue ' + (i+1): 'destino'}}
                          </label>
                          <span class="text-bold">
                            {{download.address}}
                          </span>
                        </div>
                      </mat-card-content>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Fecha de creacion de la solicitud -->
          <div class="creation-info-container mb-4">
            <div class="row">
              <mat-card-content class="col-12" permission-display [module]="permission.cargo.module"
                [functionality]="permission.cargo.showCreationDateCargo"
                [ngClass]="{'col-md-6': canSeeConsecutiveMainCargo || canSeeStateDispatch}">
                <div class="md-form">
                  <label class="title-2">Fecha de creación del servicio</label>
                  <span class="text-bold">
                    {{cargo?.creationDate ? (cargo?.creationDate | dateFormat) : '-'}}
                  </span>
                </div>
              </mat-card-content>
              <mat-card-content class="col-md-6" *ngIf="canSeeConsecutiveMainCargo">
                <div class="md-form">
                  <label class="title-2">Consolidado base</label>
                  <h5 class="text-bold">
                    {{cargo?.consecutiveMainCargo ? cargo?.consecutiveMainCargo : '-'}}
                  </h5>
                </div>
              </mat-card-content>
              <mat-card-content class="col-md-6" *ngIf="canSeeStateDispatch">
                <div class="md-form">
                  <label class="title-2">Estado del despacho</label>
                  <h5 class="text-bold">
                    {{cargo?.assignedDriver ? 'Pendiente de confirmación' :
                    cargo?.stateDispatch?.state ? cargo?.stateDispatch?.state : cargo.state === cargoStateEnum.REQUEST
                    ? 'Pendiente de revisión' : 'Programado'}}
                  </h5>
                </div>
              </mat-card-content>
              <mat-card-content class="col-md-6">
                <div class="md-form">
                  <label class="title-2">Estado</label>
                  <h5 class="text-bold">
                    {{cargoState}}
                  </h5>
                </div>
              </mat-card-content>
              <mat-card-content class="col-md-6">
                <div class="md-form">
                  <label class="title-2">Consecutivo</label>
                  <h5 class="text-bold">
                    {{cargo?.consecutive ? cargo?.consecutive : '-'}}
                  </h5>
                </div>
              </mat-card-content>
              <mat-card-content class="col-md" *ngIf="cargo?.estimatedTime">
                <div class="md-form">
                  <label class="title-2">Tiempo estimado</label>
                  <span class="text-bold">
                    {{cargo?.estimatedTime ? (cargo?.estimatedTime | duration) : '-'}}
                  </span>
                </div>
              </mat-card-content>
              <mat-card-content class="col-md" *ngIf="cargo?.realTime">
                <div class="md-form">
                  <label class="title-2">Tiempo real</label>
                  <span class="text-bold">
                    {{cargo?.realTime ? (cargo?.realTime | duration) : '-'}}
                  </span>
                </div>
              </mat-card-content>
              <mat-card-content class="col-md" *ngIf="cargo?.distancy">
                <div class="md-form">
                  <label class="title-2">Distancia</label>
                  <span class="text-bold">
                    {{cargo?.distancy ? (cargo?.distancy | mToKm) : '-'}}
                  </span>
                </div>
              </mat-card-content>
            </div>
          </div>
        </div>
      </div>

      <!-- Contractor and transport company -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.allowToEditGeneralDataModule">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            {{ showTransportCompanyInfo ? 'Contratante y empresa de transporte' : 'Información del contratante' }}
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'contractorInformation'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'contractorInformation'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-md-6 px-0 service-detail__field">
              <span>Contratante del servicio</span>
              <div class="label-field">
                {{cargo?.cargoOwner?.documentNumber === cargo?.idCompany?
                cargo?.cargoOwner?.name :
                cargo?.idCompany ? (cargo?.idCompany | companyName):''}}
                ({{cargo?.cargoOwner?.documentNumber ? cargo?.cargoOwner?.documentNumber : cargo?.idCompany ?
                cargo?.idCompany : '-'}})
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="showTransportCompanyInfo">
              <span>Empresa de transporte</span>
              <div class="label-field">
                {{cargo?.transportCompany?.name ? cargo?.transportCompany?.name : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="branchOfficeName && isTransportService">
              <span>Dirección</span>
              <div class="label-field">
                {{branchOfficeName ? branchOfficeName : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="isTransportService">
              <span>Código de sede</span>
              <div class="label-field">
                {{utils.isDefined(cargo?.cargoOwner?.branchOffice) ? cargo?.cargoOwner?.branchOffice : '-'}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional contractor information -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.allowToEditGeneralDataModule">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Información adicional del servicio
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container
            *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'contractorAdditionalInformation'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'contractorAdditionalInformation'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-md-6 px-0 service-detail__field">
              <span>Tipo de viaje</span>
              <div class="label-field">
                {{cargo?.cargoModel?.tripType?.name ? cargo?.cargoModel?.tripType?.name : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field">
              <span>Categoría de viaje</span>
              <div class="label-field">
                {{cargo?.cargoModel?.tripType?.category ? cargo?.cargoModel?.tripType?.category : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="isTransportService">
              <span>¿Requiere manifiesto?</span>
              <div class="label-field">
                {{cargo?.ministry ? 'Si' : 'No'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field">
              <span>Código identificador de cliente</span>
              <div class="label-field">
                {{cargo?.numberDocumentSender ? cargo?.numberDocumentSender : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field">
              <span>Propietario {{cargo?.ministry ? 'de las remesas' : 'del servicio'}}</span>
              <div class="label-field">
                {{cargo?.cargoOwner?.name ?
                cargo?.cargoOwner?.name : cargo?.idCompany | companyName}} ({{cargo?.cargoOwner?.documentNumber ?
                cargo?.cargoOwner?.documentNumber : cargo?.idCompany ? cargo?.idCompany : '-'}})
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" permission-display [module]="permission.cargo.module"
              [functionality]="permission.cargo.showEditTagsModule">
              <span>Etiquetas</span>
              <div class="label-field">
                {{cargo?.labels?.length ? cargo?.labels?.join(', ') : '-'}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Origin -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showLoadDownloadModule">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Origen
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'origin'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'origin'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-md-6 px-0 service-detail__field">
              <span>Ciudad de origen</span>
              <h5 class="label-field">
                {{cargo?.cargoFeature?.uploadDownload?.origin?.name ? cargo?.cargoFeature?.uploadDownload?.origin?.name
                : '-'}}
                {{cargo?.cargoFeature?.uploadDownload?.origin?.country?'('+cargo?.cargoFeature?.uploadDownload?.origin?.country?.name+')':''}}
              </h5>
            </div>
            <div class="col-md-6 px-0 service-detail__field">
              <span>Fecha {{isTransportService? 'de cargue': 'estimada de llegada al origen'}}</span>
              <h5 class="label-field">
                {{cargo?.dateLoad ? (cargo?.dateLoad | dateFormat:'only-date') : '-'}}
              </h5>
            </div>
            <div class="col-md-12 px-0 mt-3"
              *ngFor="let upload of cargo?.cargoFeature?.uploadDownload?.origin?.addresses; let i = index;">
              <!-- Dirección de cargue  -->
              <mat-card-content class='md-form'>
                <span class="label-field">Dirección {{(i+1)}}:
                  {{upload.address}}</span>
                <a class="underline color-secondary-dark text-strong float-right"
                  (click)="showEvidence(upload, upload.id, 'Origin')"
                  *ngIf="cargo?.state === cargoStateEnum.END_SERVICE">
                  Ver evidencias
                </a>
              </mat-card-content>
              <!-- Ínformación - Dirección de cargue  -->
              <div class="row">
                <!-- Hora de cargue -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse">
                  <span>{{isTransportService? 'Hora de cargue':'Hora estimada'}}</span>
                  <label class="label-field">{{utils.isDefined(upload.time) ? upload.time : '-'}}</label>
                </mat-card-content>
                <!-- Nombre de la empresa -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse"
                  *ngIf="!isTransportService && upload?.thirdPartyConsignment?.name">
                  <span>Nombre del remitente</span>
                  <label class="label-field">
                    {{upload.thirdPartyConsignment.name}}
                  </label>
                </mat-card-content>
                <!-- NIT de la empresa -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse"
                  *ngIf="!isTransportService && upload?.thirdPartyConsignment?.documentNumber">
                  <span>Documento del remitente</span>
                  <label class="label-field">{{upload.thirdPartyConsignment.documentNumber}}</label>
                </mat-card-content>

                <!-- Duration Time  -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse">
                  <span>
                    {{getTitleAddressCargoDurationTime('origin', 'start')}}
                    <span *ngIf="upload?.durationTime?.startDateSource">
                      ({{upload?.durationTime?.startDateSource === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                  </span>
                  <label class="label-field">
                    {{ upload?.durationTime?.startDate ? (upload.durationTime.startDate | dateFormat) : '-' }}
                    <span class="underline font-primary-light"
                      (click)="editAddressCargoDurationTime(upload, 'origin', 'start', i)"
                      *ngIf="upload?.durationTime?.startDate && canEditAddressCargoDurationTime && !cargo?.requiresMinistryLogisticTimes">
                      <i class="fas fa-edit"></i>
                    </span>
                    <i class="fas fa-history color-secondary-dark cursor-pointer ml-1" matTooltip="Historico de cambios"
                      matTooltipPosition="above"
                      *ngIf="canOpenHistoryCargoLogisticTimes('origin', 'startDate', i)?.canOpen"
                      (click)="openHistoryCargoLogisticTimes(upload, 'origin', 'startDate', i)"></i>
                    <i *ngIf="!!getFingerprintDescriptionByAddress(upload, 'origin', 'startDate', i)"
                      class="fas fa-info-circle color-secondary-dark cursor-pointer" matSuffix
                      [matTooltip]="getFingerprintDescriptionByAddress(upload, 'origin', 'startDate', i)"
                      matTooltipClass="tooltip__alert" matTooltipPosition="right"></i>
                  </label>
                </mat-card-content>
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse">
                  <span>
                    {{getTitleAddressCargoDurationTime('origin', 'end')}}
                    <span *ngIf="upload?.durationTime?.endDateSource">
                      ({{upload?.durationTime?.endDateSource === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                  </span>
                  <label class="label-field">
                    {{upload?.durationTime?.endDate ? (upload.durationTime.endDate | dateFormat) : '-'}}
                    <span class="underline font-primary-light"
                      (click)="editAddressCargoDurationTime(upload, 'origin', 'end', i)"
                      *ngIf="upload?.durationTime?.endDate && canEditAddressCargoDurationTime && !cargo?.requiresMinistryLogisticTimes">
                      <i class="fas fa-edit"></i>
                    </span>
                    <i class="fas fa-history color-secondary-dark cursor-pointer ml-1" matTooltip="Historico de cambios"
                      matTooltipPosition="above"
                      *ngIf="canOpenHistoryCargoLogisticTimes('origin', 'endDate', i)?.canOpen"
                      (click)="openHistoryCargoLogisticTimes(upload, 'origin', 'endDate', i)"></i>
                    <i *ngIf="!!getFingerprintDescriptionByAddress(upload, 'origin', 'endDate', i)"
                      class="fas fa-info-circle color-secondary-dark cursor-pointer" matSuffix
                      [matTooltip]="getFingerprintDescriptionByAddress(upload, 'origin', 'endDate', i)"
                      matTooltipClass="tooltip__alert" matTooltipPosition="right"></i>
                  </label>
                </mat-card-content>
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse" *ngIf="isTransportService">
                  <span>Duración de cargue</span>
                  <label class="label-field">{{ upload.durationTime && utils.isDefined(upload.durationTime.duration)
                    ?
                    (upload.durationTime.duration | millisecondsDigitalClock) : '-'}}</label>
                </mat-card-content>
                <!-- Celular -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse" *ngIf="upload?.cellphone">
                  <span>Celular</span>
                  <label class="label-field">{{upload.cellphone}}</label>
                </mat-card-content>

                <!-- Registered RMM -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse" *ngIf="upload?.rmmRegistered">
                  <span>¿Registro de monitoreo de manifiesto cargado?</span>
                  <label class="label-field">{{upload.rmmRegistered ? 'Si' : 'No'}}</label>
                </mat-card-content>


                <!-- RMM Register ID -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse" *ngIf="upload?.rmmRegisterId">
                  <span>ID de registro de monitoreo de manifiesto</span>
                  <label class="label-field">{{upload.rmmRegisterId}}</label>
                </mat-card-content>


                <!-- RMM Error Message -->
                <div class="alert alert-danger w-100 d-flex flex-wrap justify-content-between align-items-baseline"
                  *ngIf="upload?.rmmErrorMessage">
                  <p class="text-bold mr-2 m-0">
                    <i class="fas fa-exclamation-triangle mr-3"></i> Error cargando registro de monitoreo de manifiesto:
                    {{upload.rmmErrorMessage}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Destination -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showLoadDownloadModule">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Destino
          </label>
          <span class="text-right underline font-secondary-dark text-bold my-3" (click)="openDialogGuides()"
            *ngIf="cargo?.state !== cargoStateEnum.REQUEST && canOpenDialogGuides">
            <i class="fas fa-eye"></i>
            Ver guías asociadas
          </span>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'destination'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'destination'}">
          </ng-container>
          <div class="d-flex flex-wrap row-information py-0 mb-4 mt-3"
            *ngFor=" let destination of cargo?.cargoFeature?.uploadDownload?.destination; let index = index;">
            <div class="col-md-6 px-0 service-detail__field">
              <span>Ciudad de destino</span>
              <h5 class="label-field">
                {{destination?.name ? destination?.name
                : '-'}}
                {{destination?.country?'('+destination?.country?.name+')':''}}
              </h5>
            </div>
            <div class="col-md-6 px-0 service-detail__field">
              <span>Fecha {{isTransportService? 'de descargue': 'estimada de llegada al destino'}}</span>
              <h5 class="label-field">
                {{destination?.downloadDate ? (destination?.downloadDate | dateFormat:'only-date') : '-'}}
              </h5>
            </div>
            <div class="col-md-12 px-0 mt-3"
              *ngFor=" let download of destination.addresses; let indexDownload = index;">
              <!-- Dirección de descargue  -->
              <mat-card-content class="md-form">
                <span class="label-field">Dirección {{indexDownload+1}}:
                  {{download.address}}</span>
                <a class="underline color-secondary-dark text-strong float-right"
                  (click)="showEvidence(download, download.id, 'Destination', destination.id)"
                  *ngIf="cargo?.state === cargoStateEnum.END_SERVICE">
                  Ver evidencias
                </a>
              </mat-card-content>
              <!-- Ínformación - Dirección de descargue  -->
              <div class="row">
                <!-- Hora de cargue -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3"
                  *ngIf="!utils.isEmpty(download.time)">
                  <span>{{isTransportService? 'Hora de descargue':'Hora estimada'}}</span>
                  <label class="label-field">{{ utils.isDefined(download.time )? download.time : '-'}}</label>
                </mat-card-content>
                <!-- Nombre de la empresa -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3"
                  *ngIf="!isTransportService && download?.thirdPartyConsignment?.name">
                  <span>Nombre del destinatario</span>
                  <label class="label-field">{{download.thirdPartyConsignment.name}}</label>
                </mat-card-content>
                <!-- NIT de la empresa -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3"
                  *ngIf="!isTransportService && download?.thirdPartyConsignment?.documentNumber">
                  <span>Documento del destinatario</span>
                  <label class="label-field">{{download.thirdPartyConsignment.documentNumber}}</label>
                </mat-card-content>
                <!-- Inicio del descargue  -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3">
                  <span>
                    {{getTitleAddressCargoDurationTime('destination', 'start')}}
                    <span *ngIf="download?.durationTime?.startDateSource">
                      ({{download?.durationTime?.startDateSource === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                  </span>
                  <label class="label-field">
                    {{download?.durationTime?.startDate ? (download.durationTime.startDate | dateFormat) : '-'}}
                    <span class="underline font-primary-light"
                      (click)="editAddressCargoDurationTime(download, 'destination', 'start', indexDownload, index)"
                      *ngIf="download?.durationTime?.startDate && canEditAddressCargoDurationTime">
                      <i class="fas fa-edit"></i>
                    </span>
                    <i class="fas fa-history color-secondary-dark cursor-pointer ml-1" matTooltip="Historico de cambios"
                      matTooltipPosition="above"
                      *ngIf="canOpenHistoryCargoLogisticTimes('destination', 'startDate', indexDownload, index)?.canOpen"
                      (click)="openHistoryCargoLogisticTimes(download, 'destination', 'startDate', indexDownload, index)"></i>
                    <i *ngIf="!!getFingerprintDescriptionByAddress(download, 'destination', 'startDate', indexDownload, index)"
                      class="fas fa-info-circle color-secondary-dark cursor-pointer" matSuffix
                      [matTooltip]="getFingerprintDescriptionByAddress(download, 'destination', 'startDate', indexDownload, index)"
                      matTooltipClass="tooltip__alert" matTooltipPosition="right"></i>
                  </label>
                </mat-card-content>
                <!-- Finalización del descargue  -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3">
                  <span>{{getTitleAddressCargoDurationTime('destination', 'end')}}
                    <span *ngIf="download?.durationTime?.endDateSource">
                      ({{download?.durationTime?.endDateSource === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                  </span>
                  <label class="label-field">
                    {{download?.durationTime?.endDate ? (download.durationTime.endDate | dateFormat) : '-'}}
                    <span class="underline font-primary-light"
                      (click)="editAddressCargoDurationTime(download, 'destination', 'end', indexDownload, index)"
                      *ngIf="download?.durationTime?.endDate && canEditAddressCargoDurationTime">
                      <i class="fas fa-edit"></i>
                    </span>
                    <i class="fas fa-history color-secondary-dark cursor-pointer ml-1" matTooltip="Historico de cambios"
                      matTooltipPosition="above"
                      *ngIf="canOpenHistoryCargoLogisticTimes('destination', 'endDate', indexDownload, index)?.canOpen"
                      (click)="openHistoryCargoLogisticTimes(download, 'destination', 'endDate', indexDownload, index)"></i>
                    <i *ngIf="!!getFingerprintDescriptionByAddress(download, 'destination', 'endDate', indexDownload, index)"
                      class="fas fa-info-circle color-secondary-dark cursor-pointer"
                      [matTooltip]="getFingerprintDescriptionByAddress(download, 'destination', 'endDate', indexDownload, index)"
                      matTooltipClass="tooltip__alert" matTooltipPosition="right"></i>
                  </label>
                </mat-card-content>
                <!-- Duración del descargue  -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3" *ngIf="isTransportService">
                  <span>Duración de descargue</span>
                  <label class="label-field">
                    {{download?.durationTime?.duration ? (download.durationTime.duration | millisecondsDigitalClock) :
                    '-'}}
                  </label>
                </mat-card-content>


                <!-- Celular -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3" *ngIf="download?.cellphone">
                  <span>Celular</span>
                  <label class="label-field">{{download.cellphone}}</label>
                </mat-card-content>
                <!-- Email -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3" *ngIf="download?.email">
                  <span>Email</span>
                  <label class="label-field">{{download.email}}</label>
                </mat-card-content>
                <!-- Remesas -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3"
                  *ngIf="download?.consignments?.length">
                  <span>Remesas</span>
                  <label class="label-field">{{download.consignments.join(', ')}}</label>
                </mat-card-content>

                <!-- Registered RMM -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse" *ngIf="download?.rmmRegistered">
                  <span>¿Registro de monitoreo de manifiesto cargado?</span>
                  <label class="label-field">{{download.rmmRegistered ? 'Si' : 'No'}}</label>
                </mat-card-content>

                <!-- RMM Register ID -->
                <mat-card-content class="col-sm-6 col-lg-3 md-form md-form-reverse" *ngIf="download?.rmmRegisterId">
                  <span>ID de registro de monitoreo de manifiesto</span>
                  <label class="label-field">{{download.rmmRegisterId}}</label>
                </mat-card-content>

                <!-- RMM Error Message -->
                <div class="alert alert-danger w-100 d-flex flex-wrap justify-content-between align-items-baseline"
                  *ngIf="download?.rmmErrorMessage">
                  <p class="text-bold mr-2 m-0">
                    <i class="fas fa-exclamation-triangle mr-3"></i> Error cargando registro de monitoreo de manifiesto:
                    {{download.rmmErrorMessage}}
                  </p>
                </div>
              </div>
              <br>
              <!--Requisitos de cumplido-->
              <p *ngIf="canCheckCompliments" (click)="openCargoCompliments(index,indexDownload)"
                class="underline color-secondary-dark text-strong text-center cursor-pointer">
                Ver requisitos de cumplido
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Planning Route -->
      <div class="row" *ngIf="![cargoStateEnum.REQUEST, cargoStateEnum.DELETED, cargoStateEnum.EXPIRED].includes(cargo?.state)
        && (canUpdatePlanningRoute || canCheckPlanningRoute) && !isUrbanService">
        <div class="alert alert-warning w-100 d-flex flex-wrap justify-content-between align-items-baseline"
          *ngIf="!cargo?.routePlanId || !cargo?.itineraryId">
          <p class="text-center m-0 w-100">
            <b class="text-bold">Plan de ruta</b>
            <i class="fas fa-history color-secondary-dark cursor-pointer ml-1"
              *ngIf="canOpenHistoryPlanningRouteChanges() && planningRouteHistory?.length > 0"
              matTooltip="Histórico de cambios del plan de ruta" matTooltipPosition="above"
              (click)="openHistoryPlanningRouteChanges()"></i>
          </p>
          <p class="text-bold mr-2 m-0" [ngClass]="{'text-center':!canUpdatePlanningRoute}">
            <i class="fas fa-exclamation-triangle mr-3"></i> Este servicio no tiene un plan de ruta asignado
          </p>
          <button mat-raised-button class="primary-secondary my-2" color="primary" *ngIf="canUpdatePlanningRoute"
            (click)="checkPlanningRoute()">
            Asignar
          </button>
        </div>
        <div *ngIf="cargo?.routePlanId && cargo?.itineraryId" class="alert alert-info w-100">
          <p class="text-center m-0">
            <b class="text-bold">Plan de ruta asignado: </b>
            {{cargo?.cargoFeature?.uploadDownload?.origin?.name}} -
            {{cargo?.cargoFeature.uploadDownload.destination[cargo?.cargoFeature.uploadDownload.destination.length -
            1]?.name}}
            <i class="fas fa-history color-secondary-dark cursor-pointer ml-1"
              *ngIf="canOpenHistoryPlanningRouteChanges() && planningRouteHistory?.length > 0"
              matTooltip="Histórico de cambios del plan de ruta" matTooltipPosition="above"
              (click)="openHistoryPlanningRouteChanges()"></i>
          </p>
          <div class="w-100 button-container my-2">
            <button mat-raised-button class="primary-secondary" color="primary" *ngIf="canUpdatePlanningRoute"
              (click)="changeItinerary()">
              Cambiar itinerario
            </button>
            <button mat-raised-button color="primary" class="bg-color-primary" (click)="watchItineraryDetail()">
              Ver itinerario actual
            </button>
          </div>
        </div>
      </div>

      <!-- Monitor State -->
      <div class="row" *ngIf="hasMonitorStateErrors.hasErrors">
        <div class="alert alert-danger w-100 d-flex flex-column justify-content-between align-items-baseline">
          <h5 class="text-bold m-0 pb-4 text-center w-100">Errores de transmisión de Monitor</h5>
          <p class="text-bold m-0" *ngFor="let error of hasMonitorStateErrors.errors">
            <i class="fas fa-exclamation-triangle mr-3"></i> {{error}}
          </p>
        </div>
      </div>

      <!-- Vehicle type -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.editTypeVehicle" *ngIf="isEscortedService || isTransportService">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Tipo de vehículo
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'vehicleType'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'vehicleType'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-md-6 col-lg-3 px-0 service-detail__field"
              *ngIf="cargo?.cargoFeature?.vehicleType?.vehicleAlias">
              <span>Alias</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.vehicleType?.vehicleAlias}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field">
              <span>Tipo de vehículo</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.vehicleType?.name ? cargo?.cargoFeature?.vehicleType?.name : '-'}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field">
              <span>N° de ejes</span>
              <div class="label-field">
                {{cargo?.axles ? cargo?.axles : '-'}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field">
              <span>Tipo de carrocería</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.vehicleType?.bodyWorkType?.name ?
                cargo?.cargoFeature?.vehicleType?.bodyWorkType?.name : '-'}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field" *ngIf="cargo?.cargoFeature?.vehicleType?.quality">
              <span>Tipo de ambiente</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.vehicleType?.quality}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field"
              *ngIf="cargo?.cargoFeature?.vehicleType?.trailer?.bodywork">
              <span>Tipo de carrocería del tráiler</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.vehicleType?.trailer?.bodywork}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field"
              *ngIf="cargo?.cargoFeature?.vehicleType?.trailer?.axles">
              <span>N° de ejes del tráiler</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.vehicleType?.trailer?.axles}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Escorted vehicle -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showEscortInfoModule" *ngIf="isEscortedService || isSatelliteLockService">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            {{isEscortedService ? 'Vehículo escoltado' : 'Vehículo a seguir'}}
          </label>
        </div>
        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'escortedVehicle'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'escortedVehicle'}">
          </ng-container>
          <app-driver-escorted-vehicle class="d-flex flex-wrap row-information py-0 mb-4 mt-2" [cargo]="cargo"
            *ngIf="cargo?.escortedVehicle">
          </app-driver-escorted-vehicle>
        </div>
      </div>

      <!-- Service Type -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showServiceTypeModule" *ngIf="isTransportService">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Tipo de servicio
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'serviceType'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'serviceType'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-md-6 col-lg-4 px-0 service-detail__field" *ngIf="cargo?.cargoModel?.tripType?.letterRetirement 
            && cargo?.cargoModel?.tripType?.name==='Exportación'">
              <span>Carta de retiro</span>
              <app-file [options]="{title: 'Carta retiro', path: 'Cargo'+ '/' + cargo?.id + '/letterRetirement', 
                storage: true, storageName: 'tripType_letterRetirement', readOnly: true,
                firebasePath: firebasePath ? cargo?.cargoModel?.tripType?.letterRetirement : null}"
                [inputFormControl]="letterRetirement">
              </app-file>
            </div>
            <div class="col-md-6 col-lg-4 px-0 service-detail__field" *ngIf="cargo?.cargoModel?.tripType?.regimeType">
              <span>Tipo de régimen</span>
              <div class="label-field">
                {{cargo?.cargoModel?.tripType?.regimeType}}
              </div>
            </div>
            <div class="col-md-6 col-lg-4 px-0 service-detail__field" *ngIf="cargo?.cargoModel?.tripType?.date">
              <span>Fecha de vencimiento DUTA/OTM</span>
              <div class="label-field">
                {{cargo?.cargoModel?.tripType?.date | dateFormat:'only-date'}}
              </div>
            </div>
            <div class="col-md-6 col-lg-4 px-0 service-detail__field" *ngIf="cargo?.cargoModel?.cargoType?.name">
              <span>Tipo de carga</span>
              <div class="label-field">
                {{cargo?.cargoModel?.cargoType?.name}}
              </div>
            </div>
            <div class="col-md-6 col-lg-4 px-0 service-detail__field" *ngIf="cargo?.cargoModel?.serviceType?.name">
              <span>Tipo de servicio</span>
              <div class="label-field">
                {{cargo?.cargoModel?.serviceType?.name}}
              </div>
            </div>
            <div class="col-md-6 col-lg-4 px-0 service-detail__field" *ngIf="cargo?.cargoModel?.cargoType?.name === 'Contenedor' 
            && cargo?.cargoModel?.cargoType?.containerMeasure?.size">
              <span>Medidas del contenedor</span>
              <div class="label-field">
                {{cargo?.cargoModel?.cargoType?.containerMeasure?.size}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cargo characteristics -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showServiceCharacteristicsModule">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Características
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'cargoCharacteristics'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'cargoCharacteristics'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-12 px-0 service-detail__field">
              <span>Perfil de riesgo</span>
              <div class="risk-profile-block">
                <!-- Solo lectura (chip con color por nivel): el perfil se calcula automaticamente. -->
                <div class="risk-chip" [ngClass]="riskProfileClass" *ngIf="!canOverrideRiskProfile">
                  <i class="fas fa-shield-alt"></i>
                  <span>{{ cargo?.riskProfile?.name ? cargo?.riskProfile?.name : 'Sin definir' }}</span>
                </div>

                <!-- Override manual solo para el equipo de Seguridad (con confirmacion). -->
                <mat-form-field appearance="standard" class="risk-profile-select" [ngClass]="riskProfileClass"
                  *ngIf="canOverrideRiskProfile">
                  <mat-select [formControl]="riskProfileOverrideControl" placeholder="Sin definir"
                    (selectionChange)="onRiskProfileSelected($event.value)">
                    <mat-select-trigger>
                      {{ riskNameById(riskProfileOverrideControl.value) }}
                    </mat-select-trigger>
                    <mat-option *ngFor="let risk of riskProfiles" [value]="risk.id">
                      <span class="risk-dot" [ngClass]="riskClassByName(risk?.name)"></span>
                      {{ risk.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Huella del cambio manual (avatar con tooltip; visible para todos cuando existe override). -->
                <div class="risk-fingerprint-avatar" *ngIf="cargo?.riskProfileOverrideFingerprint" role="img"
                  tabindex="0" [attr.aria-label]="'Cambio manual por ' + (cargo?.riskProfileOverrideFingerprint?.userName ||
                    cargo?.riskProfileOverrideFingerprint?.userId || 'Seguridad')" [matTooltip]="'Cambio manual · ' + (cargo?.riskProfileOverrideFingerprint?.userName ||
                    cargo?.riskProfileOverrideFingerprint?.userId || 'Seguridad') +
                    (cargo?.riskProfileOverrideFingerprint?.date ?
                    (' · ' + (cargo?.riskProfileOverrideFingerprint?.date | dateFormat)) : '')"
                  matTooltipPosition="above">
                  <i class="fas fa-user-shield"></i>
                </div>

                <!-- Huella de quien continuo guardando aunque el vehiculo no cumpliera el minimo de
                     viajes del perfil de riesgo (boton "Continuar de todos modos"). -->
                <div class="risk-fingerprint-avatar" *ngIf="cargo?.vehicleTripValidationOverrideFingerprint" role="img"
                  tabindex="0" [attr.aria-label]="'Guardado sin cumplir el minimo de viajes, autorizado por ' +
                    (cargo?.vehicleTripValidationOverrideFingerprint?.userName ||
                    cargo?.vehicleTripValidationOverrideFingerprint?.userId)" [matTooltip]="'Continuó sin cumplir el mínimo de viajes · ' +
                    (cargo?.vehicleTripValidationOverrideFingerprint?.userName ||
                    cargo?.vehicleTripValidationOverrideFingerprint?.userId) +
                    (cargo?.vehicleTripValidationOverrideFingerprint?.date ?
                    (' · ' + (cargo?.vehicleTripValidationOverrideFingerprint?.date | dateFormat)) : '')"
                  matTooltipPosition="above">
                  <i class="fas fa-exclamation-triangle"></i>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field"
              *ngIf="cargo?.cargoModel?.cargoType?.name === 'Contenedor' && containerNumbersLabel">
              <span>N° de contenedor</span>
              <div class="label-field">
                {{containerNumbersLabel}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field" *ngIf="cargo?.seal && isTransportService">
              <span>Precinto</span>
              <div class="label-field">
                {{cargo?.seal}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field"
              *ngIf="cargo?.cargoModel?.cargoType?.name === 'Contenedor' && cargo?.containerExpirationDate">
              <span>Fecha de expiración del contenedor</span>
              <div class="label-field">
                {{cargo?.containerExpirationDate}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field"
              *ngIf="cargo?.cargoModel?.cargoType?.name === 'Contenedor' && cargo?.booking">
              <span>Booking</span>
              <div class="label-field">
                {{cargo?.booking}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field" *ngIf="isTransportService">
              <span>Valor declarado de la mercancia</span>
              <div class="label-field">
                {{utils.isDefined(cargo?.cargoFeature?.cargoMeasure?.amount) ?
                (cargo?.cargoFeature?.cargoMeasure?.amount |
                currency:'COP':'code') : '-'}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field" *ngIf="isTransportService">
              <span>Medida total</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.cargoMeasure?.totalMeasurement ?
                cargo?.cargoFeature?.cargoMeasure?.totalMeasurement + ' metros cúbicos' : '-'}}
              </div>
            </div>
            <div class="col-md-3 col-lg-2 px-0 service-detail__field" *ngIf="isTransportService">
              <span>N° de unidades</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.cargoMeasure?.quantity ? cargo?.cargoFeature?.cargoMeasure?.quantity : '-'}}
              </div>
            </div>
            <div class="col-md-3 col-lg-2 px-0 service-detail__field" *ngIf="isTransportService">
              <span>Peso total</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.cargoMeasure?.totalWeigth ? cargo?.cargoFeature?.cargoMeasure?.totalWeigth :
                '0'}}
                {{cargo?.cargoFeature?.cargoMeasure?.unit ? cargo?.cargoFeature?.cargoMeasure?.unit === '1' ? 'kg' :
                'gal' : 'kg'}}
              </div>
            </div>
            <div class="col-md-6 col-lg-2 px-0 service-detail__field" *ngIf="isTransportService">
              <span>Tipo de almacenamiento</span>
              <div class="label-field">
                {{cargo?.cargoFeature?.cargoMeasure?.type ? cargo?.cargoFeature?.cargoMeasure?.type : '-'}}
              </div>
            </div>
            <div class="col-md-6 col-lg-2 px-0 service-detail__field"
              *ngIf="isTransportService && totalAmountDelivered">
              <span>Peso entregado</span>
              <div class="label-field">
                {{totalAmountDelivered}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Observations -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.editSatelliteLockModule" *ngIf="isSatelliteLockService">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Candado satelital
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'satelliteLock'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'satelliteLock'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-md-6 col-lg-3 px-0 service-detail__field">
              <span>Tipo de dispositivo</span>
              <div class="label-field">
                {{cargo?.lock?.type?.name ? cargo?.lock?.type?.name : '-'}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field" *ngIf="cargo?.lock?.id">
              <span>ID del dispositivo asignado</span>
              <div class="label-field">
                {{cargo?.lock?.id}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field" *ngIf="cargo?.lock?.imei">
              <span>IMEI del dispositivo asignado</span>
              <div class="label-field">
                {{cargo?.lock?.imei}}
              </div>
            </div>
            <div class="col-md-6 col-lg-3 px-0 service-detail__field" *ngIf="cargo?.lock?.imei">
              <span>Inspección preoperacional del candado</span>
              <div>
                <span class="label-field underline cursor-pointer fs-14" (click)="openSatelliteLockInspectionDetail()"
                  matTooltip="Ver detalle de la inspección"
                  [ngClass]="satelliteLockInspection?.approval ? 'color--success': 'color--error'">
                  {{utils.isDefined(satelliteLockInspection?.approval) ? (satelliteLockInspection?.approval ? 'Aprobado'
                  :
                  'Rechazado') : 'Crear inspección'}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Service value -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showFinancialInformationModule">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Valor del servicio
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'serviceValue'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'serviceValue'}">
          </ng-container>
          <div class="d-flex flex-wrap mt-3 head" *ngIf="isTransportService || isEscortedService">
            <!-- Advance -->
            <div class="col-md-4">
              <div class="row container-title-financial">
                <span class="col-md-12">Anticipo</span>
              </div>
              <div class="row content-financial-head">
                <div class="col-md-12 item-financial">
                  <div>Valor {{utils.isDefined(cargo?.shippingCost?.advancePercentage)
                    ? (cargo?.shippingCost?.advancePercentage + "%") : ''}}
                    <span class="underline font-primary-light" (click)="openDialogNewAdvancePercentage()"
                      *ngIf="(!cargo?.shippingCost?.advanceState || !haveAdvancePayments) && !cargo?.shippingCost?.paid && 
                      ![cargoStateEnum.END_SERVICE, cargoStateEnum.DELETED, cargoStateEnum.EXPIRED].includes(cargo?.state)">
                      <i *ngIf="cargo?.shippingCost" class="fas fa-edit"></i>
                    </span>
                  </div>
                  <div class="item-price">
                    {{(cargoItemService.getPayableAdvance(cargo, balance) | currency:'COP':'code':'0.2')}}
                  </div>
                </div>

                <div class="col-md-12 item-financial">
                  <div class="color-green text-bold" *ngIf="cargo?.shippingCost?.advanceState">Pagado</div>
                  <div class="color-yellow text-bold" *ngIf="!cargo?.shippingCost?.advanceState">Por Pagar</div>
                  <div class="item-price color-secondary-dark">
                    {{(cargoItemService.getPayableAdvance(cargo, balance) | currency:'COP':'code':'0.2')}}
                  </div>
                </div>

                <div class="col-md-12 item-financial">
                  <div>Forma de pago</div>
                  <div class="item-price color-secondary-dark text__color">
                    {{cargo?.shippingCost?.advancePaymentMethod ?
                    (cargo?.shippingCost?.advancePaymentMethod)
                    :
                    '-'}}
                  </div>
                </div>

                <div
                  class="cursor-pointer item-financial col-md-12 color-secondary-dark d-flex align-items-center justify-content-between"
                  (click)="isCollapsedAdvanceInformation = !isCollapsedAdvanceInformation"
                  *ngIf="cargo?.shippingCost?.requestedAdvance?.fingerprint">
                  <u class="mr-1"><strong>¿Quién hizo la solicitud? </strong></u>
                  <mat-icon *ngIf="!isCollapsedAdvanceInformation">keyboard_arrow_down</mat-icon>
                  <mat-icon *ngIf="isCollapsedAdvanceInformation">keyboard_arrow_up</mat-icon>
                </div>
                <div class="items-dropdown row" [ngClass]="{'collapsed': isCollapsedAdvanceInformation}">
                  <div class="col-md-12 item-financial" *ngIf="cargo?.shippingCost?.requestedAdvance?.fingerprint">
                    <div>Responsable</div>
                    <div class="item-price color-secondary-dark text__color">
                      {{cargo?.shippingCost?.requestedAdvance.fingerprint.userName}}
                    </div>
                  </div>

                  <div class="col-md-12 item-financial" *ngIf="cargo?.shippingCost?.requestedAdvance?.fingerprint">
                    <div>ID</div>
                    <div class="item-price color-secondary-dark text__color">
                      {{cargo?.shippingCost?.requestedAdvance?.fingerprint?.userId}}
                    </div>
                  </div>

                  <div class="col-md-12 item-financial" *ngIf="cargo?.shippingCost?.requestedAdvance?.fingerprint">
                    <div>Fecha</div>
                    <div class="item-price color-secondary-dark text__color">
                      {{ ( cargo?.shippingCost?.requestedAdvance?.fingerprint?.date|dateFormat)}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Balance -->
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="row container-title-financial">
                <span class="col-md-12">Saldo</span>
              </div>
              <div class="row content-financial-head">
                <div class="col-md-12 item-financial">
                  <div class="color-green text-bold" *ngIf="cargo?.shippingCost?.balanceState">Pagado</div>
                  <div class="color-yellow text-bold" *ngIf="!cargo?.shippingCost?.balanceState">Por pagar</div>
                  <div class="item-price">
                    {{balance | currency:'COP':'code':'0.2'}}
                  </div>
                </div>


                <div class="col-md-12 item-financial">
                  <div>Forma de pago</div>
                  <div class="item-price color-secondary-dark text__color">
                    {{utils.isDefined(cargo?.shippingCost?.balancePaymentMethod) ?
                    (cargo?.shippingCost?.balancePaymentMethod)
                    :
                    '-'}}
                  </div>
                </div>

                <div class="col-md-12 item-financial">
                  <div>Tiempo de pago</div>
                  <div class="item-price color-secondary-dark text__color">
                    {{utils.isDefined(cargo?.shippingCost?.paymentTime)
                    ?
                    (cargo?.shippingCost?.paymentTime?.toString() + ' días') : '-'}}
                  </div>
                </div>

              </div>
            </div>
            <!-- Taxes -->
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="row container-title-financial">
                <span class="col-md-12">Impuesto</span>
              </div>
              <div class="row content-financial-head">
                <div class="col-md-12 item-financial">
                  <div>
                    Reteica
                    {{utils.isDefined(cargo?.shippingCost?.reteicaPercentage) ?
                    ((cargo?.shippingCost?.reteicaPercentage | cargoTaxes:isChargeTaxes) + '%') : ''}}
                  </div>
                  <div class="item-price">
                    {{utils.isDefined(cargo?.shippingCost?.reteicaValue)
                    ?
                    ((cargo?.shippingCost?.reteicaValue | cargoTaxes:isChargeTaxes) | currency:'COP':'code':'0.2') :
                    '-'}}
                  </div>
                </div>

                <div class="col-md-12 item-financial">
                  <div>
                    Retefuente
                    {{utils.isDefined(cargo?.shippingCost?.reteftePercentage) ?
                    ((cargo?.shippingCost?.reteftePercentage | cargoTaxes:isChargeTaxes) + '%') : ''}}
                  </div>
                  <div class="item-price">
                    {{utils.isDefined(cargo?.shippingCost?.retefteValue)
                    ?
                    ((cargo?.shippingCost?.retefteValue | cargoTaxes:isChargeTaxes) | currency:'COP':'code':'0.2') :
                    '-'}}
                  </div>
                </div>
                <div class="col-md-12 item-financial" *ngIf="isTransportService && cargo?.shippingCost?.fopatValue">
                  <div>
                    Retención FOPAT
                    {{((cargo?.shippingCost?.fopatPercentage | cargoTaxes:isChargeFopat) + '%')}}
                  </div>
                  <div class="item-price">
                    {{((cargo?.shippingCost?.fopatValue | cargoTaxes:isChargeFopat) | currency:'COP':'code':'0.2')}}
                  </div>
                </div>
                <div class="col-md-12 item-financial" *ngIf="showAppUsageDiscount">
                  <div>
                    Servicios Tecnológicos en Nube - Plataforma Digital de Transporte / Servicios adicionales
                    {{utils.isDefined(cargo?.shippingCost?.totalCost) ?
                    (cargo?.shippingCost?.integralValuesPercentage + '%') : ''}}
                  </div>
                  <div class="item-price">
                    {{utils.isDefined(cargo?.shippingCost?.totalCost)
                    ?
                    (cargo?.shippingCost?.integralValue | currency:'COP':'code':'0.2') :
                    '-'}}
                  </div>
                </div>

              </div>
            </div>
            <!-- Viáticos -->
            <div class="col-lg-4 col-md-4 col-sm-12" permission-display [module]="permission.cargo.module"
              [functionality]="permission.cargo.editTravelExpenses" *ngIf="canAccessTravelExpenses">
              <div class="row container-title-financial">
                <span class="col-md-12">Viáticos</span>
              </div>
              <div class="row content-financial-head">
                <div class="col-md-12 item-financial travel-expense-item"
                  *ngFor="let travelExpense of travelExpenses; let i=index;">
                  <div class="text-bold col-md-12 px-0">{{travelExpense?.travelExpensesType?.name}}</div>
                  <div class="text-bold"
                    [ngClass]="{'color-green': travelExpense?.paid, 'color-yellow': !travelExpense?.paid}">
                    {{travelExpense?.paid ? 'Pagado' : 'Por pagar'}}
                  </div>
                  <div class="item-price">
                    {{travelExpense.totalPaid | currency:'COP':'code':'0.2'}}
                  </div>
                </div>
                <div class="col-md-12 item-financial"
                  *ngIf="![cargoStateEnum.EXPIRED, cargoStateEnum.DELETED].includes(cargo?.state)">
                  <div (click)="showTravelExpensesDialog()"
                    class="text-bold underline color-secondary-dark cursor-pointer" *ngIf="canAddTravelExpenses">
                    Agregar
                  </div>
                  <div class="item-price underline color-secondary-dark cursor-pointer"
                    (click)="showLegalizeTravelExpensesDialog()" *ngIf="travelExpenses?.length">
                    {{!areTravelExpensesApproved ? 'Legalizar' : 'Ver'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="cargo?.journalError?.hasError">
            <div class="col-md-12 alert alert-danger" role="alert">
              {{cargo?.journalError?.description}}
            </div>
          </div>
          <div class="row" *ngIf="cargo?.additionalCosts && isTransportService">
            <div class="col-md-12">
              <app-summary-additional-cost-cargo [additionalCosts]="cargo?.additionalCosts">
              </app-summary-additional-cost-cargo>
            </div>
          </div>
          <div class="row">
            <mat-list class="col-md-12 px-0 content-financial">
              <!-- Alerta de descuento automático por abono a cartera -->
              <ng-container *ngIf="isTransportService || isEscortedService">
                <mat-list-item class="row h-auto" *ngIf="getReceivablePaymentDiscountCargoId() as receivableCargoId">
                  <div class="receivable-discount-alert d-flex align-items-start mb-3" role="alert">
                    <i class="fas fa-hand-holding-usd receivable-discount-alert__icon" aria-hidden="true"></i>
                    <div>
                      <div class="receivable-discount-alert__title">Descuento automático por abono a cartera</div>
                      <div class="receivable-discount-alert__description">
                        Este servicio tiene un descuento por abono a cartera hacia el servicio
                        <span class="receivable-discount-alert__cargo-id">{{receivableCargoId}}</span>.
                      </div>
                    </div>
                  </div>
                </mat-list-item>
              </ng-container>
              <!-- Valor de la tarifa -->
              <mat-list-item class="row h-auto" permission-display [module]="permission.cargo.module"
                [functionality]="permission.cargo.showRateCargo">
                <div class="w-100 item-financial">
                  <div>Valor inicial de la tarifa</div>
                  <div class="item-price">
                    {{
                    utils.isDefined(cargo?.shippingCost?.initialRate) ?
                    (cargo?.shippingCost?.initialRate | currency:'COP':'code') :
                    utils.isDefined(cargo?.shippingCost?.rate) ?
                    ((cargo?.shippingCost?.rate - cargoItemService.getTotalBonusesRate(cargo) +
                    cargoItemService.getTotalDiscountsRate(cargo)) | currency:'COP':'code') :
                    '-'}}
                  </div>
                </div>

              </mat-list-item>
              <!-- Valor del flete inicial -->
              <mat-list-item class="row h-auto" *ngIf="isTransportService || isEscortedService">
                <div class="w-100 item-financial">
                  <div>Valor inicial del flete<i class="fas fa-history color-secondary-dark cursor-pointer ml-1"
                      *ngIf="canOpenHistoryFreightCostChanges() && freightCostHistory?.length > 0"
                      matTooltip="Historico de cambios del flete" matTooltipPosition="above"
                      (click)="openHistoryFreightCostChanges()"></i></div>
                  <div class="item-price">
                    {{utils.isDefined(cargo?.shippingCost?.totalCost) ?
                    (cargo?.shippingCost?.totalCost | currency:'COP':'code') : '-'}}
                  </div>
                </div>
              </mat-list-item>
              <!-- El flete solo es para uso interno de LoggiApp -->
              <mat-list-item class="row h-auto" *ngIf="!!cargo?.ministry && isTransportService">
                <div class="w-100 item-financial">
                  <div>El flete solo es para uso interno de LoggiApp</div>
                  <div class="item-price">
                    {{cargo?.shippingCost?.skipFreightRNDCReport ? 'Si' : 'No'}}
                  </div>
                </div>
              </mat-list-item>
              <!--  El servicio requiere pre-factura -->
              <mat-list-item class="row h-auto">
                <div class="w-100 item-financial">
                  <div>El servicio requiere pre-factura</div>
                  <div class="item-price">
                    {{cargo?.requiresPreBill ? 'Si' : 'No'}}
                    <i class="fas fa-pencil-alt color-secondary-dark cursor-pointer" *ngIf="canEditRequiresPreBill"
                      matTooltip="Editar" matTooltipPosition="above"
                      (click)="updateRequiresPreBill(!cargo?.requiresPreBill)"></i>
                  </div>
                </div>
              </mat-list-item>
              <!--  Tiempo de vencimiento de la factura -->
              <mat-list-item class="row h-auto" *ngIf="cargo?.shippingCost?.expirationBillDays">
                <div class="w-100 item-financial">
                  <div>Tiempo de vencimiento de la factura</div>
                  <div class="item-price">
                    {{cargo?.shippingCost?.expirationBillDays === 1 ? '1 día' : cargo?.shippingCost?.expirationBillDays
                    + ' días'}}
                  </div>
                </div>
              </mat-list-item>
              <!-- Valor de Bonificaciones tarifa-->
              <mat-list-item class="row h-auto" *ngIf="cargoItemService.getTotalBonusesRate(cargo)" permission-display
                [module]="permission.cargo.module" [functionality]="permission.cargo.showRateCargo">
                <div class="w-100 item-financial">
                  <div>Valor de las Bonificaciones a la Tarifa <i
                      class="fas fa-history color-secondary-dark cursor-pointer"
                      matTooltip="Historico de bonificaciones" matTooltipPosition="above"
                      (click)="openHistoryDiscountsAndBonuses(0,'amountRate')"></i></div>
                  <div class="item-price text__color color--success">
                    {{cargoItemService.getTotalBonusesRate(cargo)
                    | currency:'COP':'code'}}
                  </div>
                </div>

              </mat-list-item>
              <!-- Valor de Bonificaciones flete-->
              <mat-list-item class="row h-auto"
                *ngIf="cargoPaymentsService.getTotalBonuses(cargo) && (isTransportService || isEscortedService)">
                <div class="w-100 item-financial">
                  <div>Valor de las Bonificaciones al Flete <i
                      class="fas fa-history color-secondary-dark cursor-pointer"
                      matTooltip="Historico de bonificaciones" matTooltipPosition="above"
                      (click)="openHistoryDiscountsAndBonuses(0, 'amount')"></i></div>
                  <div class="item-price text__color color--success">
                    {{cargoPaymentsService.getTotalBonuses(cargo) |
                    currency:'COP':'code'}}
                  </div>
                </div>

              </mat-list-item>
              <!-- Valor de Descuentos tarifa-->
              <mat-list-item class="row h-auto" *ngIf="cargoItemService.getTotalDiscountsRate(cargo)" permission-display
                [module]="permission.cargo.module" [functionality]="permission.cargo.showRateCargo">
                <div class="w-100 item-financial">
                  <div>Valor de los Descuentos a la Tarifa <i class="fas fa-history color-secondary-dark cursor-pointer"
                      matTooltip="Historico de descuentos" matTooltipPosition="above"
                      (click)="openHistoryDiscountsAndBonuses(1, 'amountRate')"></i></div>
                  <div class="item-price text__color color--error">
                    {{cargoItemService.getTotalDiscountsRate(cargo)
                    | currency:'COP':'code'}}
                  </div>
                </div>

              </mat-list-item>
              <!-- Valor de Descuentos flete -->
              <mat-list-item class="row h-auto"
                *ngIf="cargoPaymentsService.getTotalDiscounts(cargo) && (isTransportService || isEscortedService)">
                <div class="w-100 item-financial">
                  <div>Valor de los Descuentos al Flete <i class="fas fa-history color-secondary-dark cursor-pointer"
                      matTooltip="Historico de descuentos" matTooltipPosition="above"
                      (click)="openHistoryDiscountsAndBonuses(1, 'amount')"></i></div>
                  <div class="item-price  text__color color--error">
                    {{cargoPaymentsService.getTotalDiscounts(cargo) |
                    currency:'COP':'code'}}
                  </div>
                </div>

              </mat-list-item>
              <!-- Valor de la tarifa -->
              <mat-list-item class="row h-auto" permission-display [module]="permission.cargo.module"
                [functionality]="permission.cargo.showRateCargo"
                *ngIf="(cargoItemService.getTotalDiscountsRate(cargo) || cargoItemService.getTotalBonusesRate(cargo))">
                <div class="w-100 item-financial">
                  <div>Valor final de la Tarifa (aplicando descuentos y bonificaciones)</div>
                  <div class="item-price">
                    {{cargo?.shippingCost?.rate? (cargo?.shippingCost.rate|
                    currency:'COP':'code'):''}}
                  </div>
                </div>

              </mat-list-item>
              <!-- Valor del flete total  -->
              <mat-list-item class="row h-auto"
                *ngIf="(cargoPaymentsService.getTotalDiscounts(cargo) || cargoPaymentsService.getTotalBonuses(cargo) || cargoItemService.getTotalAdditionalCosts(cargo)) && (isTransportService || isEscortedService)">
                <div class="w-100 item-financial">
                  <div>Valor final del Flete (aplicando descuentos, bonificaciones y servicios adicionales)</div>
                  <div class="item-price">
                    {{cargoItemService.getRealCost(cargo) |
                    currency:'COP':'code'}}
                  </div>
                </div>

              </mat-list-item>

              <!-- Minimo valor permitido SICETAC -->
              <mat-list-item class="row h-auto" *ngIf="cargo?.minimumApprovedValueSicetac && isTransportService">
                <div class="w-100 item-financial">
                  <div>Mínimo valor flete permitido por SICETAC</div>
                  <div class="item-price color-secondary-dark">
                    {{minimumApprovedValueSicetacFormatted ? minimumApprovedValueSicetacFormatted : '-'}}
                  </div>
                </div>
              </mat-list-item>

              <!--Valor de los servicios adiciones tarifa-->
              <mat-list-item class="row h-auto"
                *ngIf="cargoItemService.getTotalAdditionalRate(cargo) && hasAdditionalCostsPermission && isTransportService"
                permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.showRateCargo">
                <div class="w-100 item-financial">
                  <div>Valor de los servicios adicionales tarifa</div>
                  <div class="item-price">
                    {{cargoItemService.getTotalAdditionalRate(cargo) |
                    currency:'COP':'code'}}
                  </div>
                </div>

              </mat-list-item>
              <!--Valor de los servicios adiciones flete-->
              <mat-list-item class="row h-auto"
                *ngIf="cargoItemService.getTotalAdditionalCosts(cargo) && hasAdditionalCostsPermission && isTransportService"
                permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.showCostCargo">
                <div class="w-100 item-financial">
                  <div>Valor de los servicios adicionales flete</div>
                  <div class="item-price">
                    {{cargoItemService.getTotalAdditionalCosts(cargo) |
                    currency:'COP':'code'}}
                  </div>
                </div>

              </mat-list-item>
              <!-- Valor de los servicios adicionales -->
              <mat-list-item class="row h-auto" *ngIf="hasAdditionalCostsPermission && isTransportService">
                <div class="w-100 item-financial">
                  <div>Valor de los servicios adicionales</div>
                  <div class="item-price underline color-secondary-dark" (click)="showAdditionalServiceCargo()">
                    {{ cargo?.additionalCosts?.length ?
                    'Ver o agregar Servicios Adicionales' :
                    'Agregar Servicios Adicionales'}}
                  </div>
                </div>

              </mat-list-item>
              <mat-list-item class="row h-auto"
                *ngIf="additionalCostsDeleted?.length && hasAdditionalCostsPermission && isTransportService">
                <div class="w-100 item-financial">
                  <div>Servicios adicionales eliminados</div>
                  <div class="item-price underline color-secondary-dark" (click)="openHistoryAdditionalCostsDeleted()">
                    Ver listado
                  </div>
                </div>

              </mat-list-item>
              <mat-list-item class="row h-auto"
                *ngIf="bonusAndDiscountsDeleted?.length && hasDeletedBonusesAndDiscountsPermission">
                <div class="w-100 item-financial">
                  <div>Bonificaciones y descuentos eliminados</div>
                  <div class="item-price underline color-secondary-dark"
                    (click)="openHistoryBonusOrPaymentsDeleted('bonus')">
                    Ver listado
                  </div>
                </div>
              </mat-list-item>

              <!-- Valor pagado -->
              <mat-list-item class="row h-auto" *ngIf="isTransportService || isEscortedService">
                <div class="w-100 item-financial">
                  <div>Valor pagado<i class="fas fa-history color-secondary-dark cursor-pointer"
                      *ngIf="showPaymentsHistoryIcon" matTooltip="Historico de Pagos" matTooltipPosition="above"
                      (click)="openHistoryPayments(3)"></i></div>
                  <div class="item-price color-secondary-dark">
                    {{cargo?.shippingCost?.totalPaid ? (cargo?.shippingCost?.totalPaid | currency:'COP':'code') : '-'}}
                  </div>
                </div>
              </mat-list-item>
              <mat-list-item class="row h-auto"
                *ngIf="paymentsDeleted?.length && hasDeletedPaymentsPermission && (isTransportService || isEscortedService)">
                <div class="w-100 item-financial">
                  <div>Pagos eliminados</div>
                  <div class="item-price underline color-secondary-dark"
                    (click)="openHistoryBonusOrPaymentsDeleted('payment')">
                    Ver listado
                  </div>
                </div>
              </mat-list-item>
              <mat-list-item class="row h-auto" *ngIf="transferredPayments?.length">
                <div class="w-100 item-financial">
                  <div>Pagos transferidos</div>
                  <div class="item-price underline color-secondary-dark" (click)="openTransferredPayments()">
                    Ver listado
                  </div>
                </div>
              </mat-list-item>
            </mat-list>
          </div>
          <div class="row py-3 justify-content-center" *ngIf="canValidateCargo(true) || canValidateCargo(false)">
            <button mat-raised-button color="primary" class="bg-color-primary button-width-auto"
              (click)="validateService()" *ngIf="canValidateCargo(true)">
              Validar servicio
            </button>
            <button mat-raised-button class="primary-secondary button-width-auto" color="primary"
              (click)="reverseValidation()" *ngIf="canValidateCargo(false)">
              Reversar validación
            </button>
          </div>

        </div>
      </div>

      <!-- Observations -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showServiceTypeModule">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Observaciones
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'observations'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'observations'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-md-6 px-0 service-detail__field">
              <span>Observaciones internas</span>
              <div class="label-field">
                {{cargo?.observation ? cargo?.observation : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="isTransportService || isEscortedService">
              <span>Requisitos para el {{isTransportService? 'conductor': 'escolta'}}</span>
              <div class="label-field">
                {{cargo?.observationDriver ? cargo?.observationDriver : '-'}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Manifest -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showConsignmentServiceModule" *ngIf="cargo?.ministry">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Manifiesto y remesas
          </label>
        </div>

        <div class="service-detail__content px-3">
          <div class="col-12 px-3 pt-4 pb-3 mt-3 mb-3 alert alert-info document-recreation-alert"
            *ngIf="documentRecreationInProgress" role="status">
            <div class="d-flex align-items-start">
              <i class="fas fa-sync-alt fa-spin mr-3 mt-1" aria-hidden="true"></i>
              <div>
                <div class="text-bold">{{documentRecreationInProgressTitle}}</div>
                <div>{{documentRecreationInProgressMessage}}</div>
                <small>
                  Las acciones para crear, editar, anular, cumplir o retransmitir documentos están temporalmente
                  bloqueadas.
                </small>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'manifest'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'manifest'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-md-12 px-0 d-flex justify-content-center alert alert-info" role="alert"
              *ngIf="canEmitConsignmentRNDC">
              <i class="fas fa-exclamation-circle mr-2"></i>
              <span>
                Algunas remesas no han sido emitidas al RNDC correctamente, para volver a emitirlas
                <u (click)="reemitConsignmentsToRndc()" class="cursor-pointer">haga clic aquí</u>
              </span>
            </div>
            <div class="col-md-6 px-0 service-detail__field">
              <span>Tipo de manifiesto</span>
              <div class="label-field">
                {{cargo?.manifestType?.description ? cargo?.manifestType?.description : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="cargo?.manifestType?.code === 'D'">
              <span>Cantidad de viajes en el día</span>
              <div class="label-field">
                {{cargo?.manifestDailyTripsCount ? cargo?.manifestDailyTripsCount : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="cargo?.cargoModel?.operationType?.description">
              <span>Tipo de operación</span>
              <div class="label-field">
                {{cargo?.cargoModel?.operationType?.description}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="cargo?.monitoringCompany?.name">
              <span>Empresa de monitoreo</span>
              <div class="label-field">
                {{cargo?.monitoringCompany?.name}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="cargo?.manifest" permission-display
              [module]="permission.cargo.module" [functionality]="permission.cargo.readManifest">
              <span>N° de Manifiesto</span>
              <div class="label-field">
                {{cargo?.manifest ? cargo?.manifest : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="cargo?.manifestAuthorization" permission-display
              [module]="permission.cargo.module" [functionality]="permission.cargo.readManifest">
              <span>Autorización de manifiesto</span>
              <div class="label-field">
                {{cargo?.manifestAuthorization ? cargo?.manifestAuthorization : '-'}}
              </div>
            </div>
            <div class="col-md-6 px-0 service-detail__field" *ngIf="rndcFulfillManifestHistory?.data?.approvalId"
              permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.readManifest">
              <span>Radicado de cumplido del manifiesto</span>
              <div class="label-field">
                {{rndcFulfillManifestHistory?.data?.approvalId}}
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap row-information py-0 mb-4 mt-3"
            *ngFor=" let destination of cargo?.cargoFeature?.uploadDownload?.destination; let index = index;">
            <div class="col-md-12 px-0 mt-3 d-flex flex-wrap"
              *ngFor=" let download of destination.addresses; let indexDownload = index;">
              <div class="col-12 px-0 d-flex flex-wrap"
                *ngFor="let consignment of download?.consignments; let consignmentIndex = index">
                <mat-card-content class="col-12 px-0 mb-2 d-flex flex-wrap align-items-center justify-content-between">
                  <div
                    class="d-flex flex-column flex-md-row justify-content-between align-items-center flex-grow-1 pr-2">
                    <div>
                      <span class="label-field">Remesa {{consignment}}</span>
                    </div>
                    <div class="text-right d-flex flex-column flex-lg-row"
                      *ngIf="cargoConsignments[consignment]?.entryId || cargoConsignments[consignment]?.approvalId">
                      <p class="label-color text-bold mb-0" *ngIf="cargoConsignments[consignment]?.entryId">
                        Radicado Generación: {{cargoConsignments[consignment]?.entryId}}
                      </p>
                      <p class="ml-2 label-color text-bold mb-0" *ngIf="cargoConsignments[consignment]?.approvalId">
                        <span class="d-none d-lg-inline">| </span>Radicado Cumplido:
                        {{cargoConsignments[consignment]?.approvalId}}
                      </p>
                    </div>
                  </div>
                  <div><span class="color--error cursor-pointer" permission-display [module]="permission.cargo.module"
                      [functionality]="permission.cargo.deleteConsignment" *ngIf="canDeleteOrCreateCargoConsignments"
                      (click)="confirmDeleteConsignment(consignment)">
                      <i class="fas fa-trash"></i>Anular
                    </span></div>
                </mat-card-content>

                <!-- Campos dinámicos de remesa -->
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3"
                  *ngFor="let field of cargoConsignmentsFields[consignment]; trackBy: trackByConsignmentField">
                  <span>
                    {{field?.label}}
                    <span class="underline" [ngClass]="{
                        'cursor-pointer color-primary': canEditCargoConsignments.canEdit, 
                        'color--disabled cursor-no-drop': !canEditCargoConsignments.canEdit}" permission-display
                      [module]="permission.cargo.module" [functionality]="permission.cargo.editConsignment"
                      (click)="goToEditConsignment(consignment, field?.edit?.modificationCode, index, indexDownload)"
                      *ngIf="field?.edit?.isEditable">
                      <i class="fas fa-edit"></i>
                    </span>
                  </span>
                  <label class="label-field">
                    {{field?.value ? field?.value : field?.auxiliaryValue ? field?.auxiliaryValue : '-'}}
                  </label>
                </mat-card-content>
                <mat-card-content class="md-form md-form-reverse col-sm-6 col-lg-3"
                  *ngIf="canReverseInitialCompliment(indexDownload, index, consignment)"
                  (click)="reverseCompliment(index, indexDownload, consignment)" permission-display
                  [module]="permission.cargo.module" [functionality]="permission.cargo.deleteConsignment">
                  <span>Cumplido inicial</span>
                  <label class="label-field underline cursor-pointer color-primary-dark">
                    Anular cumplido inicial
                  </label>
                </mat-card-content>

                <!--Errores de la remesa-->
                <div class="col-12 alert alert-danger text-center text-bold" role="alert"
                  *ngIf="cargoConsignmentsAlerts[consignment]">
                  {{cargoConsignmentsAlerts[consignment]}}
                </div>
              </div>
              <div class="consignment-error" *ngIf="download?.ministryError?.error && !rndcContingencyActive">
                <i class="fas fa-triangle-exclamation"></i> {{download.ministryError.error}}
              </div>
            </div>
          </div>
          <div class="col-12 px-0 my-3 d-flex justify-content-center" permission-display
            [module]="permission.cargo.module" [functionality]="permission.cargo.generateNewConsignment"
            *ngIf="canDeleteOrCreateCargoConsignments">
            <button mat-raised-button class="primary-secondary button-width-auto w-100" color="secondary-dark"
              (click)="generateNewConsignment()">
              Generar nueva remesa
            </button>
          </div>

        </div>
      </div>

      <!-- Publish Zone -->
      <div class="service-detail" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showServiceTypeModule" *ngIf="isTransportService">
        <div class="w-100 px-3 wrapper-label">
          <label class="title-1 m-0">
            Publicación
          </label>
        </div>

        <div class="service-detail__content px-3">
          <ng-container *ngTemplateOutlet="errorsBySectionTemplate; context: { section: 'publishZone'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="editSectionTemplate; context: { section: 'publishZone'}">
          </ng-container>
          <div class="row row-information py-0 mb-4 mt-2">
            <div class="col-12 px-0 service-detail__field">
              <span>Zona de publicación</span>
              <div class="label-field" *ngIf="cargo?.zone === 'private'">
                <b>Privada:</b> Visible solo para los conductores
                directamente asociados a la compañía.
              </div>
              <div class="label-field" *ngIf="cargo?.zone === 'public'">
                <b>Pública:</b> Visible para todos los conductores de la comunidad LoggiApp.
              </div>
              <div class="label-field" *ngIf="cargo?.zone === 'reserved'">
                <b>Reservada:</b> Reservada para la asignación de un conductor
                que está confirmado que tomará el servicio.
              </div>
              <div class="label-field" *ngIf="!cargo?.zone">
                No se ha registrado un tipo de zona de publicación
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Creación del servicio -->
      <mat-card class="container-financiera" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showCargoCreator">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Creación del servicio</span>
          </div>
        </div>
        <div class="row content-financial">
          <div class="col-md-12">
            <div class="item-financial">
              <div>Responsable de la Creación</div>
              <div class="item-price">
                <i class="fas fa-user-edit cursor-pointer font-primary-light" permission-display
                  [functionality]="permission.cargo.editCargoFingerprint" [module]="permission.cargo.module"
                  [matTooltip]="cargo?.numberDocumentCreatorLoad ? 'Cambiar responsable' : 'Asignar responsable'"
                  (click)="editFingerPrintUser('Responsable de la Creación', 'numberDocumentCreatorLoad', 
                  {name: cargoCreator?.information?.name, document: cargo?.numberDocumentCreatorLoad})"></i>
                {{cargoCreator?.information?.name ? cargoCreator?.information?.name : '-'}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>ID del responsable:</div>
              <div class="item-price">
                {{cargo?.numberDocumentCreatorLoad ? cargo?.numberDocumentCreatorLoad : '-'}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>Correo del responsable:</div>
              <div class="item-price">
                {{cargoCreator?.email ? cargoCreator?.email : '-'}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>Fecha de Creación:</div>
              <div class="item-price">
                {{cargo?.creationDate ? (cargo?.creationDate | dateFormat) : '-'}}
              </div>
            </div>

          </div>
        </div>
      </mat-card>

      <!-- Asignación -->
      <mat-card class="container-financiera"
        *ngIf="isRootNit && cargo?.assignedVehicleFingerPrint && cargo?.driver && cargo?.licensePlate"
        permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showAssignedServiceInfoModule">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Asignación del {{isEscortedService ? 'escolta' : isSatelliteLockService ?
              'candado satelital' : 'vehículo'}}</span>
          </div>
        </div>
        <div class="row content-financial">
          <div class="col-md-12">
            <div class="item-financial">
              <div>Responsable de la Asignación</div>
              <div class="item-price">
                <i class="fas fa-user-edit cursor-pointer font-primary-light" permission-display
                  [functionality]="permission.cargo.editCargoFingerprint" [module]="permission.cargo.module"
                  matTooltip="Cambiar responsable" *ngIf="cargo?.assignedVehicleFingerPrint?.userId"
                  (click)="editFingerPrintUser('Responsable de la Asignación', 'assignedVehicleFingerPrint', 
                  {name: cargo?.assignedVehicleFingerPrint?.userName, document: cargo?.assignedVehicleFingerPrint?.userId})"></i>
                {{cargo?.assignedVehicleFingerPrint?.userName? cargo?.assignedVehicleFingerPrint.userName:"-"}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>ID del responsable:</div>
              <div class="item-price">
                {{cargo?.assignedVehicleFingerPrint?.userId? cargo?.assignedVehicleFingerPrint.userId:"-"}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>Fecha de Asignación:</div>
              <div class="item-price">
                {{cargo?.assignedVehicleFingerPrint?.date? (cargo?.assignedVehicleFingerPrint.date |
                dateFormat) :'-'}}
              </div>
            </div>

          </div>
        </div>
      </mat-card>

      <!-- Confirmación -->
      <mat-card class="container-financiera mb-3" *ngIf="isRootNit && cargo?.confirmedDriver" permission-display
        [module]="permission.cargo.module" [functionality]="permission.cargo.showApprovalServiceInfoModule">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Confirmación del {{isEscortedService ? 'escolta' : isSatelliteLockService ?
              'candado satelital' : 'vehículo'}}</span>
          </div>
        </div>
        <div class="row content-financial">
          <div class="col-md-12">
            <div class="item-financial">
              <div>Responsable de la Confirmación</div>
              <div class="item-price">
                <i class="fas fa-user-edit cursor-pointer font-primary-light" permission-display
                  [functionality]="permission.cargo.editCargoFingerprint" [module]="permission.cargo.module"
                  matTooltip="Cambiar responsable" *ngIf="cargo?.confirmedDriverFingerprint?.userId"
                  (click)="editFingerPrintUser('Responsable de la Confirmación', 'confirmedDriverFingerprint', 
                  {name: cargo?.confirmedDriverFingerprint?.userName, document: cargo?.confirmedDriverFingerprint?.userId})"></i>
                {{cargo?.confirmedDriverFingerprint?.userName? cargo?.confirmedDriverFingerprint.userName:"-"}}
              </div>
            </div>

          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>ID del responsable:</div>
              <div class="item-price">
                {{cargo?.confirmedDriverFingerprint?.userId? cargo?.confirmedDriverFingerprint.userId:"-"}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>Fecha de Confirmación:</div>
              <div class="item-price">
                {{cargo?.confirmedDriverFingerprint?.date?(cargo?.confirmedDriverFingerprint.date |
                dateFormat) :'-'}}
              </div>
            </div>

          </div>
        </div>
      </mat-card>

      <!-- Desvinculación del trailer -->
      <mat-card class="container-financiera" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showTrailerReassignmentInfoModule"
        *ngIf="cargo?.trailerReassignedFingerprint">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Desvinculación del trailer</span>
          </div>
        </div>
        <div class="row content-financial">
          <div class="col-md-12">
            <div class="item-financial">
              <div>Trailer desvinculado</div>
              <div class="item-price">
                {{cargo?.trailerId ? cargo?.trailerId : '-'}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>Responsable de la Desvinculación</div>
              <div class="item-price">
                {{cargo?.trailerReassignedFingerprint?.userName ? cargo?.trailerReassignedFingerprint?.userName : '-'}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>ID del responsable:</div>
              <div class="item-price">
                {{cargo?.trailerReassignedFingerprint?.userId ? cargo?.trailerReassignedFingerprint?.userId : '-'}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="item-financial">
              <div>Fecha de Desvinculación:</div>
              <div class="item-price">
                {{cargo?.trailerReassignedFingerprint?.date ? (cargo?.trailerReassignedFingerprint?.date | dateFormat) :
                '-'}}
              </div>
            </div>

          </div>
        </div>
      </mat-card>

      <!-- Finalización -->
      <mat-card class="container-financiera"
        *ngIf="isRootNit && cargo?.state=='End service' && cargo?.finishedByFingerprint" permission-display
        [module]="permission.cargo.module" [functionality]="permission.cargo.showEndServiceInfoModule">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Finalización del servicio</span>
          </div>
        </div>
        <div class="row content-financial">
          <div class="col-12">
            <div class="item-financial">
              <div>Responsable de la Finalización:</div>
              <div class="item-price">
                <i class="fas fa-user-edit cursor-pointer font-primary-light" permission-display
                  [functionality]="permission.cargo.editCargoFingerprint" [module]="permission.cargo.module"
                  matTooltip="Cambiar responsable" *ngIf="cargo?.finishedByFingerprint?.userId" (click)="editFingerPrintUser('Responsable de la Finalización', 'finishedByFingerprint', 
                  {name: cargo?.finishedByFingerprint?.userName, document: cargo?.finishedByFingerprint?.userId})"></i>
                {{ cargo?.finishedByFingerprint?.userName ? cargo?.finishedByFingerprint?.userName : '-'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>ID del responsable:</div>
              <div class="item-price">
                {{ cargo?.finishedByFingerprint?.userId ? cargo?.finishedByFingerprint?.userId : '-'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>Fecha de Finalización:</div>
              <div class="item-price">
                {{ cargo?.finishedByFingerprint?.date ? (cargo?.finishedByFingerprint?.date | dateFormat) : '-'}}
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Calificación -->
      <mat-card class="container-financiera" *ngIf="cargo?.state === cargoStateEnum.END_SERVICE" permission-display
        [module]="permission.cargo.module" [functionality]="permission.cargo.rateCargo">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Calificación del servicio</span>
          </div>
        </div>
        <div class="row content-financial">
          <div class="col-12">
            <div class="item-financial">
              <div>Puntaje:</div>
              <div class="item-price">
                {{utils.isDefined(cargo?.cargoScore?.creatorScore)?
                cargo?.cargoScore?.creatorScore: '-'}}
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="cargo?.cargoScore?.reason">
            <div class="item-financial">
              <div>Motivo:</div>
              <div class="item-price">
                {{cargo.cargoScore.reason}}
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="!cargo?.cargoScore">
            <div class="item-financial justify-content-end">
              <div class="item-price cursor-pointer underline color-secondary-dark" (click)="rateCargo()">
                Calificar
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Aprobación -->
      <mat-card class="container-financiera" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.viewApproveInfo" *ngIf="cargo?.state === cargoStateEnum.END_SERVICE">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Aprobación</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 content-financial">
            <div class="row">
              <div class="col-md-12">
                <div class="item-financial">
                  <div>Estado: </div>
                  <div class="item-price">
                    {{cargo && utils.isDefined(cargo?.approval) ? (cargo?.approval === 'Approved' ?
                    'Aprobado' : cargo?.approval === 'Rejected' ? 'Rechazado' : 'Pendiente de aprobación') :
                    ''}}
                  </div>
                </div>

              </div>
              <div class="col-md-12"
                *ngIf="cargo?.approvalUserName && ['Approved', 'Rejected'].includes(cargo?.approval)">
                <div class="item-financial">
                  <div>Responsable {{cargo?.approval === 'Approved' ? 'de la aprobación' : 'del rechazo' }}: </div>
                  <div class="item-price">
                    <i class="fas fa-user-edit cursor-pointer font-primary-light" permission-display
                      [functionality]="permission.cargo.editCargoFingerprint" [module]="permission.cargo.module"
                      matTooltip="Cambiar responsable" *ngIf="cargo?.approvalUserId && cargo?.approvalUserName" (click)="editFingerPrintUser('Responsable de la Aprobación', 'approvalUserId', 
                    {name: cargo?.approvalUserName, document: cargo?.approvalUserId})"></i>
                    {{cargo?.approvalUserName}}
                  </div>
                </div>
              </div>
              <div class="col-md-12"
                *ngIf="cargo?.approvalUserId && ['Approved', 'Rejected'].includes(cargo?.approval)">
                <div class="item-financial">
                  <div>ID del responsable:</div>
                  <div class="item-price">
                    {{cargo?.approvalUserId}}
                  </div>
                </div>
              </div>
              <div class="col-md-12" *ngIf="cargo?.approvalDate && ['Approved', 'Rejected'].includes(cargo?.approval)">
                <div class="item-financial">
                  <div>Fecha de {{cargo?.approval === 'Approved' ? 'aprobación' : 'rechazo'}}:</div>
                  <div class="item-price">
                    {{cargo?.approvalDate | dateFormat}}
                  </div>
                </div>
              </div>
              <div class="col-md-12" *ngIf="cargo?.approval === 'Rejected'">
                <div class="item-financial">
                  <div>Razón del rechazo: </div>
                  <div class="item-price">
                    {{utils.isDefined(cargo?.reasonApproval) ? (cargo?.reasonApproval) :
                    ''}}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Validación del servicio -->
      <mat-card class="container-financiera" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.viewValidateCargoInfo"
        *ngIf="cargo?.prevalidation?.fingerprint && requiresPreValidation">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Validación del servicio</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 content-financial">
            <div class="row">
              <div class="col-md-12">
                <div class="item-financial">
                  <div>Estado: </div>
                  <div class="item-price">
                    {{cargo?.prevalidation?.valid ? 'Validado' : 'Pendiente de validación'}}
                  </div>
                </div>

              </div>
              <div class="col-md-12" *ngIf="cargo?.prevalidation?.fingerprint?.userName">
                <div class="item-financial">
                  <div>Responsable {{(cargo?.prevalidation?.valid ? 'de la validación' : 'del rechazo')}}: </div>
                  <div class="item-price">
                    <i class="fas fa-user-edit cursor-pointer font-primary-light" permission-display
                      [functionality]="permission.cargo.editCargoFingerprint" [module]="permission.cargo.module"
                      matTooltip="Cambiar responsable"
                      *ngIf="cargo?.prevalidation?.fingerprint?.userId && cargo?.prevalidation?.fingerprint?.userName && cargo?.prevalidation?.valid"
                      (click)="editFingerPrintUser('Responsable de la Validación', 'prevalidationFingerprint', 
                    {name: cargo?.prevalidation?.fingerprint?.userName, document: cargo?.prevalidation?.fingerprint?.userId})"></i>
                    {{cargo?.prevalidation?.fingerprint?.userName}}
                  </div>
                </div>
              </div>
              <div class="col-md-12" *ngIf="cargo?.prevalidation?.fingerprint?.userId">
                <div class="item-financial">
                  <div>ID del responsable:</div>
                  <div class="item-price">
                    {{cargo?.prevalidation?.fingerprint?.userId}}
                  </div>
                </div>
              </div>
              <div class="col-md-12" *ngIf="cargo?.prevalidation?.fingerprint?.date">
                <div class="item-financial">
                  <div>Fecha de {{cargo?.prevalidation?.valid ? 'validación' : 'rechazo'}}:</div>
                  <div class="item-price">
                    {{cargo?.prevalidation?.fingerprint?.date | dateFormat}}
                  </div>
                </div>
              </div>
              <div class="col-md-12" *ngIf="!cargo?.prevalidation?.valid && cargo?.prevalidation?.observation">
                <div class="item-financial">
                  <div>Razón de reversión de validación: </div>
                  <div class="item-price">
                    {{cargo?.prevalidation?.observation}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Responsable de cumplido del manifiesto y remesas -->
      <mat-card class="container-financiera"
        *ngIf="cargo?.state==cargoStateEnum.END_SERVICE && canViewRndcFulfillHistory() && (rndcFulfillManifestHistory || rndcFulfillConsignmentHistory)">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Cumplimiento de manifiesto y remesas</span>
          </div>
        </div>
        <div class="row content-financial" *ngIf="rndcFulfillManifestHistory">
          <div class="col-12">
            <div class="item-financial">
              <div>Responsable de cumplido del manifiesto {{isSameRndcFulfillResponsible() ? 'y remesas' : ''}}:</div>
              <div class="item-price">
                {{ rndcFulfillManifestHistory?.fingerprint?.userName ? rndcFulfillManifestHistory?.fingerprint?.userName
                : '-'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>ID del responsable:</div>
              <div class="item-price">
                {{ rndcFulfillManifestHistory?.fingerprint?.userId ? rndcFulfillManifestHistory?.fingerprint?.userId :
                '-'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>Fecha de cumplido del manifiesto {{isSameRndcFulfillResponsible() ? 'y remesas' : ''}}:</div>
              <div class="item-price">
                {{ rndcFulfillManifestHistory?.fingerprint?.date ? (rndcFulfillManifestHistory?.fingerprint?.date |
                dateFormat) : '-'}}
              </div>
            </div>
          </div>
        </div>
        <div class="row content-financial" *ngIf="rndcFulfillConsignmentHistory && !isSameRndcFulfillResponsible()">
          <div class="col-12">
            <div class="item-financial">
              <div>Responsable de cumplido de las remesas:</div>
              <div class="item-price">
                {{ rndcFulfillConsignmentHistory?.fingerprint?.userName ?
                rndcFulfillConsignmentHistory?.fingerprint?.userName : '-'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>ID del responsable:</div>
              <div class="item-price">
                {{ rndcFulfillConsignmentHistory?.fingerprint?.userId ?
                rndcFulfillConsignmentHistory?.fingerprint?.userId : '-'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>Fecha de cumplido de las remesas:</div>
              <div class="item-price">
                {{ rndcFulfillConsignmentHistory?.fingerprint?.date ? (rndcFulfillConsignmentHistory?.fingerprint?.date
                | dateFormat) : '-'}}
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Facturación -->
      <mat-card class="container-financiera mb-3" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showBillingData" *ngIf="cargo?.state === cargoStateEnum.END_SERVICE">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Facturación</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <ng-container>
                <div class="col-md-6 item-financial flex-column">
                  <div>Numero de Factura: </div>
                  <div class="item-price">
                    {{utils.isDefined(cargo?.shippingCost?.billId) ?
                    (cargo?.shippingCost?.billId) : '-'}}
                  </div>
                </div>
                <div class="col-md-6 item-financial flex-column">
                  <div>Fecha de Expedición Factura: </div>
                  <div class="item-price">
                    {{cargo?.expeditionDateBill ? (cargo?.expeditionDateBill | dateFormat:'only-date') : '-'}}
                  </div>
                </div>
                <div class="col-md-6 item-financial flex-column">
                  <div>Numero de Comprobante de Ingreso: </div>
                  <div class="item-price">
                    {{utils.isDefined(cargo?.shippingCost?.incomeId) ?
                    (cargo?.shippingCost.incomeId) : '-'}}
                  </div>
                </div>
                <div class="col-md-6 item-financial flex-column">
                  <div>
                    Comprobante Contable:
                    <i permission-display [module]="permission.payments.module"
                      [functionality]="permission.payments.downloadJournalCargoPDF" *ngIf="cargo.journalIdSiigo"
                      class="fas fa-file-pdf underline color-secondary-dark cursor-pointer"
                      (click)="getCargoJournalIdPDF()"></i>
                  </div>
                  <div class="item-price">
                    {{cargo && utils.isDefined(cargo?.journalIdSiigo) ?
                    (cargo?.journalIdSiigo) : '-'}}
                    <!-- Generate Journal -->
                    <label *ngIf="paymentsHistoryToDisplay?.length && cargo?.journalError?.hasError"
                      class="underline color-secondary-dark cursor-pointer" (click)="confirmGenerateJournal()"
                      permission-display [module]="permission.payments.module"
                      [functionality]="permission.payments.generateJournalCargo">
                      Generar Comprobante
                    </label>
                  </div>
                </div>
                <div class="col-md-6 item-financial flex-column">
                  <div>Fecha de Expedición Comprobante: </div>
                  <div class="item-price">
                    {{cargo?.expeditionDateJournal ? (cargo?.expeditionDateJournal | dateFormat: 'only-date') : '-'}}
                  </div>
                </div>
                <div class="col-md-6 item-financial flex-column">
                  <div>Responsable de la facturación: </div>
                  <div class="item-price">
                    {{cargo?.billedBy?.userName ? cargo?.billedBy?.userName : '-'}}
                  </div>
                </div>

                <div class="col-md-6 item-financial flex-column">
                  <div>ID del responsable: </div>
                  <div class="item-price">
                    {{cargo?.billedBy?.userId ? cargo?.billedBy?.userId : '-'}}
                  </div>
                </div>
                <div class="col-md-6 item-financial flex-column">
                  <div>Fecha de Facturación:</div>
                  <div class="item-price">
                    {{cargo?.billedBy?.date ? (cargo?.billedBy.date |
                    dateFormat: 'only-date') :'-'}}
                  </div>
                </div>
              </ng-container>

              <div class="col-md-6 item-financial flex-column"
                *ngIf="!uploadDownloadMapService?.getHasSiigoIntegration()">
                <div>Centro de costo</div>
                <div class="item-price">
                  {{cargo?.costCenter?.name ? cargo?.costCenter?.name : '-'}}
                </div>
              </div>
              <div class="col-md-6 item-financial flex-column" *ngIf="cargo?.preBill">
                <div>Pre-factura asociada</div>
                <div class="item-price">
                  {{cargo?.preBill ? cargo?.preBill : '-'}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div permission-display [module]="permission.cargo.module"
          [functionality]="permission.cargo.assignUnassignCostCenterToService"
          *ngIf="!uploadDownloadMapService?.getHasSiigoIntegration()">
          <div class="row mt-3">
            <div class="container-title-financial col-md-12 mb-0">
              <span class="text-financial">Centro de costo</span>
            </div>
          </div>
          <div class="row">
            <app-assign-cost-center [company]="ownerCompany" [cargo]="cargo" [initialValue]="cargo?.costCenter"
              [transportCompanyId]="cargo?.transportCompany?.id" (emitResult)="processCostCenter($event)"
              class="col-md-12"></app-assign-cost-center>
          </div>
        </div>
      </mat-card>

      <!-- Resumen de la negociación del servicio -->
      <div *ngIf="isNegotiation && authService.cargoActive.negotiation.driver" permission-display
        [module]="permission.cargo.module" [functionality]="permission.cargo.showEditServiceNegotiationModule">
        <div class="row">
          <div class="col-md-12 wrapper-label margin">
            <label for="" class="title-1 w-auto">
              Resumen de la negociación del servicio
            </label>
          </div>
        </div>
        <!-- Información - Resumen de la negociación del servicio -->
        <div class="row row-information">
          <!-- Flete inicial -->
          <div class="col-md-3" permission-display [module]="permission.cargo.module"
            [functionality]="permission.cargo.showTotalCostCargo">
            <mat-card-content>
              <div class="md-form md-form-reverse">
                <span>Flete inicial del servicio</span>
                <label class="label-field">{{utils.isDefined(cargo?.shippingCost?.totalCost) ?
                  (cargo?.shippingCost.totalCost | currency:'COP':'code') : '-'}}</label>
              </div>
            </mat-card-content>
          </div>
          <!-- Oferta del conductor -->
          <div class="col-md-3">
            <mat-card-content>
              <div class="md-form md-form-reverse">
                <span>Oferta del conductor</span>
                <label class="label-field">{{utils.isDefined(authService.cargoActive.negotiation.negotiatedValueDriver)
                  ? (authService.cargoActive.negotiation.negotiatedValueDriver | currency:'COP':'code') :
                  '-'}}</label>
              </div>
            </mat-card-content>
          </div>
          <!-- Tu contraoferta -->
          <div class="col-md-3">
            <mat-card-content>
              <div class="md-form md-form-reverse">
                <span>Tu contraoferta</span>
                <label class="label-field">{{utils.isDefined(authService.cargoActive.negotiation.negotiatedValueCreator)
                  ? (authService.cargoActive.negotiation.negotiatedValueCreator | currency:'COP':'code') :
                  '-'}}</label>
              </div>
            </mat-card-content>
          </div>
          <!-- Respuesta del conductor -->
          <div class="col-md-3">
            <mat-card-content>
              <div class="md-form md-form-reverse">
                <span>Estado</span>
                <label class="label-field">
                  {{getStateNegotiation(authService.cargoActive.negotiation.state)}}
                </label>
              </div>
            </mat-card-content>
          </div>
        </div>
      </div>

      <!-- Resumen de la negociación de la solicitud -->
      <div *ngIf="isNegotiationRequest && authService.cargoActive.negotiationRequest.companyId" permission-display
        [module]="permission.cargo.module" [functionality]="permission.cargo.showEditRequestNegotiationModule">
        <div class="row">
          <div class="col-md-12 wrapper-label margin">
            <label for="" class="title-1 w-auto">
              Resumen de la negociación de la solicitud
            </label>
          </div>
        </div>
        <!-- Información - Resumen de la negociación de la solicitud  -->
        <div class="row row-information">
          <!-- Flete inicial -->
          <div class="col-md-3" permission-display [module]="permission.cargo.module"
            [functionality]="permission.cargo.showTotalCostCargo">
            <mat-card-content>
              <div class="md-form md-form-reverse">
                <span>Flete inicial del servicio</span>
                <label class="label-field">{{utils.isDefined(cargo?.shippingCost?.totalCost) ?
                  (cargo?.shippingCost.totalCost | currency:'COP':'code') : '-'}}</label>
              </div>
            </mat-card-content>
          </div>
          <!-- Oferta de la empresa -->
          <div class="col-md-3">
            <mat-card-content>
              <div class="md-form md-form-reverse">
                <span>Oferta de la Empresa: {{authService.cargoActive.negotiationRequest.companyId}}</span>
                <label
                  class="label-field">{{utils.isDefined(authService.cargoActive.negotiationRequest.negotiatedValueCompany)
                  ? (authService.cargoActive.negotiationRequest.negotiatedValueCompany | currency:'COP':'code') :
                  '-'}}</label>
              </div>
            </mat-card-content>
          </div>
          <!-- Tu contraoferta -->
          <div class="col-md-3">
            <mat-card-content>
              <div class="md-form md-form-reverse">
                <span>Tu contraoferta</span>
                <label
                  class="label-field">{{utils.isDefined(authService.cargoActive.negotiationRequest.negotiatedValueCreator)
                  ? (authService.cargoActive.negotiationRequest.negotiatedValueCreator | currency:'COP':'code') :
                  '-'}}</label>
              </div>
            </mat-card-content>
          </div>
          <!-- Respuesta del conductor -->
          <div class="col-md-3">
            <mat-card-content>
              <div class="md-form md-form-reverse">
                <span>Estado</span>
                <label class="label-field">
                  {{getStateNegotiation(authService.cargoActive.negotiationRequest.state)}}
                </label>
              </div>
            </mat-card-content>
          </div>
        </div>
      </div>

      <!-- Eliminación -->
      <mat-card class="container-financiera"
        *ngIf="isRootNit && cargo?.state==cargoStateEnum.DELETED && cargo?.deletedFingerPrint" permission-display
        [module]="permission.cargo.module" [functionality]="permission.cargo.showDeleteServiceInfoModule">
        <div class="row">
          <div class="container-title-financial col-md-12">
            <span class="text-financial">Eliminación del servicio</span>
          </div>
        </div>
        <div class="row content-financial">
          <div class="col-12">
            <div class="item-financial">
              <div>Responsable de la Eliminación</div>
              <div class="item-price">
                {{cargo?.deletedFingerPrint?.fingerPrint?.userName? cargo?.deletedFingerPrint.fingerPrint.userName:"-"}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>ID del responsable:</div>
              <div class="item-price">
                {{cargo?.deletedFingerPrint?.fingerPrint?.userId? cargo?.deletedFingerPrint.fingerPrint.userId:"-"}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>Fecha de Eliminación:</div>
              <div class="item-price">
                {{cargo?.deletedFingerPrint?.fingerPrint?.date? (cargo?.deletedFingerPrint.fingerPrint.date |
                dateFormat) :'-'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item-financial">
              <div>Observación:</div>
              <div class="item-price">
                {{cargo?.deletedFingerPrint?.observation? cargo?.deletedFingerPrint.observation:"-"}}
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Conductor asignado -->
      <div class="row m-0 p-0" *ngIf="isNegotiation || (driver && driver.phone && vehicle && vehicle.id)"
        permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.showDriverInfoModule">
        <div class="col-md-12 wrapper-label margin mt-4">
          <label for="" class="title-1 w-auto">
            {{isNegotiation ? 'Conductor en negociación' : isEscortedService ? 'Escolta asignado':'Conductor asignado'}}
          </label>
        </div>
      </div>
      <app-driver-cargo class="row row-information" [cargo]="cargo" *ngIf="driver && driver.phone && vehicle?.id"
        [driver]="driver" [vehicle]="vehicle" [isNegotiation]="isNegotiation" [secondDriver]="secondDriver"
        (emitDriver)="updateDriver($event)" (emitVehicle)="updateVehicle($event)"
        (containerInspectionSaved)="onRefreshCargo($event)" (refreshLoad)="getCargoDetailById($event)"
        permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.showDriverInfoModule">
      </app-driver-cargo>
      <!-- Acciones -->
      <div class="row" *ngIf="!isDialog" permission-display [module]="permission.cargo.module"
        [functionality]="permission.cargo.showActionsServiceModule">
        <div *ngIf="cargo?.manifestError?.error && !rndcContingencyActive && cargo?.ministryError"
          class="col-12 m-0 p-0">
          <div class="manifest-alert d-flex d-flex flex-column">
            <p class="m-0 p-0 text-center manifest-alert__title">Errores en el manifiesto</p>
            <span *ngFor="let manifestError of manifestErrors" class="d-flex align-items-center">
              <i class="fas fa-exclamation-circle mr-2"></i>
              <div>{{manifestError}}</div>
            </span>
          </div>
        </div>
        <div class="col-md-12 px-0">
          <mat-card-actions
            class="actions-card d-flex flex-column flex-sm-row justify-content-center justify-content-sm-around align-items-center flex-wrap mx-0 px-0">
            <button mat-raised-button color="primary" class="mx-0 mb-2" (click)="goToList()">
              Ir {{getListName()? 'a ' + getListName() : 'al listado'}}
            </button>
            <app-generate-manifest-action *ngIf="cargo?.ministry && ((!cargo?.manifestAuthorization && !rndcContingencyActive) || (rndcContingencyActive && !cargo?.manifest)) &&
            [cargoStateEnum.ACCEPTED, cargoStateEnum.START_SERVICE, cargoStateEnum.END_SERVICE].includes(cargo?.state)"
              [cargo]="cargo" type="button-detail"
              (refreshLoad)="getCargoDetailById($event)"></app-generate-manifest-action>
            <!-- Negotiation Cargo -->
            <button mat-raised-button color="primary" *ngIf="isRequest||isOffer" (click)="acceptOffer()">
              Aceptar oferta
            </button>
            <button mat-raised-button class="primary-secondary" color="primary" *ngIf="isRequest||isOffer"
              (click)="rejectOffer()">
              Rechazar oferta
            </button>
            <!-- Request  -->
            <!--button mat-raised-button color="primary" *ngIf="!isNegotiation && listActive === 'request' && isSubCompany"
              (click)="openModalAcceptRequest()">
              Aceptar oferta
            </button>
            <button mat-raised-button class="primary-secondary mb-2" color="primary"
              *ngIf="!isNegotiation && listActive === 'request' && isSubCompany"
              (click)="openModal('modalNegotiationRequest')">
              Negociar oferta
            </button-->
            <!-- Parent Negotiation Rquest -->
            <app-cargo-options *ngIf="listActive !== 'serviceRequests'" [type]="'button'"
              [cargo]="getCargoWithMergedPayments() || cargo" (refreshCargo)="onRefreshCargo($event)"
              (openVehicle)="openVehicle()" (showInspection)="showInspection()" class="mb-2">
            </app-cargo-options>
            <div class="cancel-cargo"
              *ngIf="[cargoStateEnum.ACCEPTED, cargoStateEnum.CREATED, cargoStateEnum.REQUEST].includes(cargo?.state) && cargo?.driver && !cargo?.consecutiveMainCargo"
              permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.cancelCargo">
              <a (click)="cancelCargo()">Desasociar Vehículo</a>
            </div>
          </mat-card-actions>
        </div>
      </div>
    </div>
  </div>
</aside>

<!-- Modal Refuse Cargo -->
<ng-template #modalRefuseCargo let-modal>
  <div class="modal-body wrapper-modal" *ngIf="cargo?.id">
    <p class="title">
      ¿Quieres enviarle al conductor tu contraoferta?
    </p>
    <mat-form-field appearance="outline" class="px-3">
      <mat-label>Valor<span class="asterisk">*</span></mat-label>
      <input matInput type="text" mask="separator.0" thousandSeparator="." placeholder="Ejm: 1.000.000"
        [formControl]="negotiationValue">
      <mat-error *ngIf="negotiationValue.errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
    </mat-form-field>
    <div class="button-container my-3">
      <button mat-raised-button color="primary" class="bg-color-primary mx-2" (click)="negotiateCargo()">Enviar
        contraoferta</button>
      <div class="mt-2 mx-2">
        <a (click)="refuseCargo()">No, mantener flete inicial</a>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal Negotiation Request -->
<ng-template #modalNegotiationRequest let-modal>
  <div class="modal-body wrapper-modal" *ngIf="cargo?.id">
    <p class="title">
      Escribe el valor
    </p>
    <mat-form-field appearance="outline" class="px-3">
      <mat-label>Valor<span class="asterisk">*</span></mat-label>
      <input matInput type="text" mask="separator.0" thousandSeparator="." placeholder="Ejm: 1.000.000"
        [formControl]="negotiationRequestValue">
      <mat-error *ngIf="negotiationRequestValue.errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
    </mat-form-field>
    <div class="button-container my-3">
      <button mat-raised-button color="primary" class="bg-color-primary" (click)="negotiateRequest()"
        mdbWavesEffect>Enviar contraoferta</button>
    </div>
  </div>
</ng-template>

<!-- Modal Confirm Refuse Request -->
<app-modal #modalConfirmRefuseRequest [titleModal]="'¿Está seguro que quiere rechazar esta negociación?'"
  [titleCancel]="titles.titleModalNo" [titleConfirm]="titles.titleModalConfirm" (onCancel)="onCancel($event)"
  (onConfirm)="onConfirmRefuseRequest()"></app-modal>

<!-- Modal Confirm Accept Request -->
<app-modal #modalConfirmAcceptRequest
  [titleModal]="'¿Está seguro que quiere aceptar esta ' + (isParentCompany ? 'negociación' : 'oferta' ) +'?'"
  [titleCancel]="titles.titleModalNo" [titleConfirm]="titles.titleModalConfirm" (onCancel)="onCancel($event)"
  (onConfirm)="onConfirmAcceptRequest()"></app-modal>

<!-- Modal Confirm Accept Cargo -->
<app-modal #modalConfirmAcceptCargo [titleModal]="'¿Está seguro que quiere aceptar esta oferta?'"
  [titleCancel]="titles.titleModalNo" [titleConfirm]="titles.titleModalConfirm" (onCancel)="onCancel($event)"
  (onConfirm)="onConfirmAcceptCargo()"></app-modal>

<!-- Modal Confirm Negotiation Cargo -->
<ng-template #modalConfirmNegotiationCargo let-modal>
  <div class="modal-body wrapper-modal" *ngIf="cargo?.id">
    <p>
    <figure class="container-icon-correct">
      <img src="/assets/svg/icons/icon-correct-purple.svg" alt="">
    </figure>
    </p>
    <p class="title">
      Tu contraoferta ha sido enviada
    </p>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="closeModalConfirmNegotiation()" mdbWavesEffect>
        Volver a servicios en negociación
      </button>
    </mat-card-actions>
  </div>
</ng-template>

<!-- Register Payment -->
<app-register-cargo-payment #modalRegisterCargoPayment [cargo]="cargo" (onRegisterPayment)="onRegisterPayment($event)">
</app-register-cargo-payment>

<!-- List Payments -->
<app-list-cargo-payments #modalListCargoPayments *ngIf="paymentsHistoryToDisplay?.length" [cargo]="cargo"
  [payments]="paymentsHistoryToDisplay"></app-list-cargo-payments>

<ng-template #modalCargoPDF let-modal>
  <div class="modal-body wrapper-modal modal-content-PDF" *ngIf="cargoPDF">
    <embed [src]="cargoPDF" type="application/pdf">
  </div>
</ng-template>

<!-- Modal Error RNDC Approve Cargo -->
<ng-template #modalErrorRNDCApproveCargo let-modal>
  <div class="modal-body wrapper-modal">
    <p>
    <figure class="container-icon-correct">
      <img src="/assets/svg/icons/icon-error-purple.svg" alt="">
    </figure>
    </p>
    <p class="title">
      ¡Ocurrió un error al aprobar el servicio!
    </p>
    <div>
      <ul>
        <li class="title-2" *ngFor="let error of errorRNDC">
          {{error}}
        </li>
      </ul>
    </div>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="dismissAllModals()">Aceptar</button>
    </mat-card-actions>
  </div>
</ng-template>

<ng-template #errorsBySectionTemplate let-section="section">
  <div class="col-12 alert alert-danger text-center text-bold" role="alert"
    *ngIf="canSeeSectionErrors && errorsBySection[section]">
    <i class="fas fa-exclamation-circle mr-2"></i>
    {{errorsBySection[section]}}
  </div>
</ng-template>

<ng-template #editSectionTemplate let-section="section">
  <div class="d-flex justify-content-end mt-2" *ngIf="canEditSections(section)">
    <span class="p-2 edit-section" (click)="editSection(section)">
      <i class="fas fa-edit"></i>
      Editar sección
    </span>
  </div>
</ng-template>